import {
  Component,
  OnInit,
  NgZone,
  HostListener,
  AfterViewInit,
  Renderer2,
  ElementRef,
  ViewChild,
  QueryList,
  ViewChildren,
  Output,
  ChangeDetectorRef,
  ViewContainerRef,
} from "@angular/core";
import { SelectedBankQuestionsService } from "./../../shared/services/selected-bank-questions.service";
import { ShareDataService } from "../../shared/services/shared.service";
import { Subject, Subscription } from "rxjs";
import { KebabMenuInterface } from "./../../shared/models/kebab-menu-model";
import { QuestionFilterPipe } from "./../../shared/pipes/question-filter.pipe";
import { Collection } from "./../../shared/models/collection.model";
import { References } from "../../shared/models/references.model";
import { MetaData } from "../../shared/models/metadata.model";
import { HeaderData } from "./../../shared/models/header-items";
import { FilterTestCategoryComponent } from "../filter-test-category/filter-test-category.component";
import { PageEvent } from "../../shared/components/pager";
import { MheOption } from "../../shared/components/shared";
import { AlertType } from "../../shared/components/alert/alert-type";
import { ButtonType } from "../../shared/components/button/button-type";
import { ButtonPurpose } from "../../shared/components/button/button-purpose";
import {
  CdkDragDrop,
  moveItemInArray,
  CdkDrag,
  CdkDropList,
  CdkDragEnter
} from '@angular/cdk/drag-drop';
import { ActivatedRoute, NavigationStart, Router } from "@angular/router";
import { environment } from "../../../environments/environment";
import { SourceBankComponent } from "src/app/shared/components/source-bank/source-bank.component";
import { BankModel } from "src/app/shared/models/bank.model";
import { ExamStatisticRes } from "src/app/shared/models/examstatres.model";
import { ButtonComponent } from "src/app/shared/components/button";
import { closeOpenTooltips, getKebabElements } from "src/app/utils/shared-utils";
import { QUESTION_ADDED_SUCCESS_MESSAGE, QUESTION_EDITED_SUCCESS_MESSAGE, ADD_SUCCESS_MSG_SINGLE_QUESTION, ADD_SUCCESS_MSG_MULTIPLE_QUESTIONS, REMOVE_SUCCESS_MSG_SINGLE_QUESTION, REMOVE_SUCCESS_MSG_MULTIPLE_QUESTIONS, UPDATE_POINTS_SUCCESS_MSG, FOOTER_OFFSET_HEIGHT, LARGE_VIEW_HEIGHT_OFFSET_BODY, SMALL_VIEW_HEIGHT_OFFSET_BODY, MEDIUM_SCREEN_BREAKPOINT_PX, MEDIUM_SCREEN_HEIGHT_BREAKPOINT_PX, SMALL_SCREEN_BREAKPOINT_PX } from "src/app/utils/stringConstants";
import { InputComponent } from "src/app/shared/components/input/input.component";
import { CheckboxComponent } from "src/app/shared/components/checkbox";
import { QuestionTypeDropdownComponent } from "src/app/shared/components/question-type-dropdown/question-type-dropdown.component";
import { SelectSourceQuestion } from "src/app/shared/models/select-source-question.model";
import { TooltipDirective } from "src/app/shared/components/tooltip";
import { KeyAction } from "src/app/utils/keyActions";
import { LiveAnnouncer, FocusMonitor } from "@angular/cdk/a11y";
import { Title } from "@angular/platform-browser";
import { KebabComponent } from "src/app/shared/components/kebab/kebab.component";
import { TabsComponent } from "src/app/shared/components/tabs/tabs.component";

@Component({
    selector: "app-source-select",
    templateUrl: "./source-select.component.html",
    styleUrls: ["./source-select.component.scss"],
    standalone: false
})
export class SourceSelectComponent implements OnInit, AfterViewInit {
  shouldAutoFocusSourcePicker = false;
  questionList: any;
  questionList1: any;
  bankObj: any;
  ezidObj: any;
  subscribedData: any;
  screenHeight: number;
  screenWidth: number;
  showBank: boolean = true;
  pinnedQuestionList = [];
  pinnedQuestionListIndex = [];
  previewUrl = [];
  qIndex: Number;
  closeModalPopUp: Boolean = false;
  sourcePickerCompHeight: number;
  sourcePickerDestiHeight: number;
  searchWidthLeft: number = 0;
  leftAddButtonAlignment: number = 0;
  totalQuestionCount: number = 0;
  leftFilterAlignment: number = 0;
  rightFilterAlignment: number = 0;
  rightSearchAlignment: number = 0;
  searchWidthRight: number = 0;
  sourcePickerTableCompHeight: number;
  headerData: HeaderData = new HeaderData();
  collection: Collection;
  operationMode = "sourceSelect";
  collectionId: String = "";
  textSearchLeft: string = "";
  selectedTitle = { selected: false };
  renameActivated = true;
  showQuestion: boolean = false;
  dragOperation = false;
  draggedArrayLength: number;
  selectedQuestions = { select: true };
  kebabMenu: KebabMenuInterface;
  searchedTextRight: string = "";
  totalSearchCountRight: number = 0;
  sectionBreakKebabMenu: KebabMenuInterface;
  partQuestionKebabMenu: KebabMenuInterface;
  mulQuestionActionsMenu: KebabMenuInterface;
  panelExpanded: boolean = false;
  hasExpanded: boolean = false;
  panelExpandedRight: boolean = false;
  panelClosed: boolean = false;
  truncateTitle: number = 50;
  truncateChapter: number = 34;
  showCreateButton: boolean = true;
  searchResultsAnnouncement: string = "";
  finalFilterCount: number = 0;
  titleTruncateLength: string = "18";
  expandAllSubject = new Subject<void>();
  public message =
    "Are you sure you want to remove this question from your test?";
  public alertMessage = "Points should be in between 1 to 99";
  public size = { width: 302 };
  public showModal = false;
  public modalShow = true;
  public buttonType = ButtonType;
  public _buttonPurpose = ButtonPurpose;
  public showSettings = false;
  public selectedQuestionsListObj;
  public selectedQuestionsList = [];
  public editQuestionList = [];
  private arrayIndex = 0;
  private questionIdArray = [];
  public hideHeader: boolean = false;
  COPYABLE = "COPYABLE";
  private readonly pageTitle = 'Source Selection | Test Builder';
  step: String = "step1";
  public tabIndex = 0;
  enableAdd = 0;
  count: any = 0;
  filterJsonObject: any = {};
  public algoImgUrl =
    environment.assests + "/assets/img/connect_sprite_icon2.png";
  public kebabIndex: number;
  private sectionBreakRemoveObj: any;
  private sectionPartsRemoveObj: any;
  private lastTriggeringKebabButton: HTMLElement | null = null;
  public showSectionBreakQuestionDeleteModal: boolean = false;
  public deleteMessage: String;
  public secBreakRemove: boolean;
  public partQuestionRemove: boolean;
  public searchText = "";
  public DeleteModalHeader: String;
  public isPreviewTestQuestions: boolean = false;
  public isPreviewSourceQuestions: boolean = false;
  public previewQuestionsList = [];
  public previewSourceQuestionsList = [];
  subs = new Subscription();
  public previewHeaderText: string = "Previewing all questions";
  public questionIndex: any = "0";
  public sectionBreakQuestionStore = [];
  public selectedQuestionsListObjStore;
  public pointAlignment: string = "point-alignment";
  public typeAlignment: string = "type-alignment";
  public expandToggleText: string = "Expand All";
  public addToTestAnnouncement: string = '';
  public deselectedIndex: number | null = null;
  public tempAddRemoveMessage: string;
  public mulQuestionActionKebabShow: boolean = false;
  public mulQuestionActionKebabOptionShow: boolean = false;
  public showFilterBtnTooltip: boolean = false;
  private defaultTitleCharLength: string = "18";
  private smallViewTitleCharLength: string = "15"
  private truncateWidthLimit: number = 350;
  private previousTotalQuestions: number = 0;
  private previousTotalPoints: number = 0;
  private isComponentInitializing: boolean = true;
  private readonly sourcePickerVerticalOffset = 335;
  private readonly sourcePickerTableVerticalOffset = 420;
  private closeTimer: NodeJS.Timeout | null = null;
  public pointsInstruction: string = 'Enter a point value between 0.00 and 1000.00';
  public suppressAnnouncement: boolean = false;
  private readonly successAlertDuration: number = 8000;
  private readonly removalAnnouncementDelay: number = 1500;
  reorderMessage: string;
  grabbedQuestion: SelectSourceQuestion;
  grabbedIndex: number;
  showSuccessMessage: boolean = false;
  alertSuccessMessage: string = ADD_SUCCESS_MSG_MULTIPLE_QUESTIONS;
  updatePointsValidInputClass = "valid-input";
  updatePointsInvalidInputClass = "invalid-input";
  modalIsVisible: boolean = false;
  updatePointsValidationObject: any = {
    isDisableUpdatePoints: true,
    callFromUpdatePoints: false,
    showInvalidMessage: "",
    errorMessageAnnouncement: ""
  };

  bulkUpdatePointInputValue: string = "";
  bulkUpdatePointsSelectedQuestionCount: number = 0;
  public alertType = AlertType;
  selectedQuestionArray = new Map();
  currentPageIndex: number = 0;
  firstItemIndex: number = 0;
  totalLength: number = 0;
  pageSize: number = 20;
  questionCollection: any = {};
  ngModelOptions: MheOption[] = [
    {
      value: 0,
      viewValue: "Create New Test",
      actionType: 'page'
    },
    {
      value: 1,
      viewValue: "Import Test",
      actionType: 'modal'
    },
  ];
  createTestText: string = "Create Test";
  @ViewChild(SourceBankComponent) sourceBank: SourceBankComponent;
  @ViewChild("createQuestionDropdown") createQuestionDropdown: QuestionTypeDropdownComponent;
  @ViewChild('clearSearchInputRight') clearSearchInputRight!: InputComponent;
  @ViewChild('clearSearchInputLeft') clearSearchInputLeft!: InputComponent;
  @ViewChild('dropZoneNoQuestion') dropZoneNoQuestion: ElementRef;
  @ViewChild('dropZoneWithQuestion') dropZoneWithQuestion: ElementRef;
  @ViewChild('dropZoneKeyboard') dropZoneKeyboard: ElementRef;
  @ViewChildren('dragHandle') dragHandles: QueryList<ElementRef<HTMLInputElement>>;
  @ViewChildren(TooltipDirective) dragHandleTooltips: QueryList<TooltipDirective>;
  @ViewChildren("questionCheckbox") questionCheckboxes!: QueryList<CheckboxComponent>;
  @ViewChildren("checkbox") partCheckboxes!: QueryList<CheckboxComponent>;
  @ViewChild("updatePointsInput") updatePointsInput!: InputComponent;
  @ViewChild('leftPanelHeader') leftPanelHeader: ElementRef<HTMLDivElement>;
  @ViewChild('step1Heading') step1Heading!: ElementRef<HTMLElement>;
  @ViewChild('selectAll') selectAllCheckboxRef!: CheckboxComponent;
  @ViewChild('changeSourceButton') changeSourceButton!: ButtonComponent;

  isExpand: boolean = true;
  textExpand: string = "Expand All";
  examStatisticsModalIsVisible: boolean = false;
  error: String = "";
  examStatsticsList: any = ExamStatisticRes;
  currentFocusedElement: HTMLElement;
  isReordered: boolean = false;
  reorderedQuestionIndex: number;
  tempAddedQuestion: SelectSourceQuestion;
  showDropHint: boolean;
  constructor(
    private elem: ElementRef,
    private render: Renderer2,
    private questionListPipe: QuestionFilterPipe,
    private sourceBankQuestion: SelectedBankQuestionsService,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private ngZone: NgZone,
    private shareDataService: ShareDataService,
    private liveAnnouncer: LiveAnnouncer,
    private focusMonitor: FocusMonitor,
    private titleService: Title
  ) {
    router.events.subscribe((event: NavigationStart) => {
      if (event.navigationTrigger === "popstate") {
        this.router.navigate(["/list"]);
      }
    });
  }

  @ViewChild(FilterTestCategoryComponent) child: FilterTestCategoryComponent;
  @ViewChild(SourceBankComponent) sourceBankComponent!: SourceBankComponent;
  @ViewChild('tempAddedQuestionContainer') tempAddedQuestionContainer: ElementRef;
  @ViewChildren('questionKebab', { read: ViewContainerRef }) questionKebabs: QueryList<ViewContainerRef>;
  @ViewChildren('partKebab', { read: ElementRef }) partKebabs: QueryList<ElementRef>;
  @ViewChild(TabsComponent) tabsComponent!: TabsComponent;

  ngOnInit() {
    this.onResize();
    this.kebabMenu = {
      addNewPart: false,
      get_info: false,
      preview: true,
      pinUnpin: true,
      edit: false,
      copy: false,
      export: false,
      rename: false,
      print: false,
      delete: false,
      remove: true,
      pastUsage: true,
      editQuestion: true,
      copyAndEdit: true,
      moveUp: true,
      moveDown: true,
      moveToTestPanel: false
    };
    this.sectionBreakKebabMenu = {
      addNewPart: true,
      get_info: false,
      preview: true,
      pinUnpin: true,
      edit: false,
      copy: false,
      export: false,
      rename: false,
      print: false,
      delete: false,
      remove: true,
      pastUsage: true,
      editQuestion: true,
      copyAndEdit: true,
      moveUp: true,
      moveDown: true
    };
    this.partQuestionKebabMenu = {
      addNewPart: false,
      get_info: false,
      preview: true,
      pinUnpin: false,
      edit: false,
      copy: false,
      export: false,
      rename: false,
      print: false,
      delete: false,
      remove: true,
      pastUsage: true,
      editQuestion: true,
      copyAndEdit: true,
    };
    this.mulQuestionActionsMenu = {
      addNewPart: false,
      get_info: false,
      preview: false,
      pinUnpin: false,
      edit: false,
      copy: false,
      export: false,
      rename: false,
      print: false,
      delete: false,
      remove: false,
      pastUsage: false,
      editQuestion: false,
      copyAndEdit: false,
      updatePointsModal: true,
      removeQuestionsModal: true,
    };

    this.shareDataService.getCurrentStep().subscribe((stepName) => {
      this.step = stepName;
      // This line uses Angular CDK's FocusMonitor to programmatically set keyboard focus to the step1Heading element.
      // It is typically used for accessibility: when the step changes (e.g., after navigation or content update),
      // this ensures that screen readers and keyboard users are taken to the main heading of the new content.
      // The 'program' origin means the focus is set by code, not by user interaction.
      // Move focus to the current step heading so screen-reader and keyboard users land on the new content.
      if (this.step1Heading?.nativeElement) {
        this.focusMonitor.focusVia(this.step1Heading.nativeElement, 'program');
      }
      if (stepName === 'step1') {
        this.titleService.setTitle(this.pageTitle);
        // In SPAs, screen readers don't auto-detect title changes. LiveAnnouncer explicitly announces the page title for accessibility.
        this.queueLiveAnnouncement(this.pageTitle, 'assertive');
      }
    });

    this.headerData = this.shareDataService.getHeaderData();
    if (this.headerData !== undefined && this.headerData != null) {
      this.collectionId = this.headerData.getCollectionId();
    }
    // Initialize previous values at the end of ngOnInit
    if (this.headerData) {
      this.previousTotalQuestions = this.headerData.getTotalQuestion() || 0;
      this.previousTotalPoints = this.headerData.getTotalPoints() || 0;
    }
    this.getEditData();
    this.setCollectionInfoInHeader();
    this.isComponentInitializing = false;
  }

  @HostListener("document:click", ["$event"])
  clickout(event) {
    const { kebabButton, kebabIcon } = getKebabElements(event.target);

    if (!kebabButton && !kebabIcon) {
      if (event.srcElement.id != "kebab-item-add-new-part") {
        this.kebabIndex = -1;
      }
    }
    if (document.getElementsByClassName("ahe-ui-alert-modal").length > 0) {
      this.kebabIndex = -1;
    }
    if (event.target.id === "expandPanel") {
      this.truncateTitle = 100;
      this.truncateChapter = 50;
      // this.panelExpanded = true;
    } else if (event.target.id === "collapsePanel") {
      this.truncateTitle = 50;
      this.truncateChapter = 34;
      //  this.panelExpanded = false;
    }
  }

  public setKebabIndex(index: number) {
    // If clicking on the same kebab that's already open, close it
    if (this.kebabIndex === index) {
      this.kebabIndex = -1;
      return;
    }
    this.kebabIndex = index;
  }
  expandPanel(panel: string) {
    if (panel === "left") {
      this.panelExpanded = !this.panelExpanded;
    } else {
      this.panelExpandedRight = !this.panelExpandedRight;
    }
  }
  receiveDataWhileChecked($event) {
    const previousCount = this.enableAdd;
    this.enableAdd = $event;

    // Announce button state only when there is a change
    if (previousCount === 0 && this.enableAdd > 0) {
      this.liveAnnouncer.announce('Add to Test button enabled.', 'polite', 1000);
    } else if (previousCount > 0 && this.enableAdd === 0) {
      this.liveAnnouncer.announce('Add to Test button disabled.', 'polite', 1000);
    }
  }

  public createCollectionObject() {
    this.collection = new Collection(
      Number(this.collectionId) || 0,
      Date.now(),
      Intl.DateTimeFormat().resolvedOptions().timeZone
    );

    const metaDataArr: MetaData[] = new Array();
    if (this.headerData) {
      metaDataArr.push(new MetaData("title", this.headerData.getTitle()));
    } else {
      metaDataArr.push(new MetaData("title", "Unnamed Test"));
    }
    this.collection.setMetaData(metaDataArr);

    const questionsList = this.selectedQuestionsListObj;
    const isbn = localStorage.getItem("isbn");
    let algoPresent = false;
    if (questionsList && questionsList.length > 0) {
      const referencesArr: References[] = new Array();
      this.selectedQuestionsListObj.forEach((question) => {
        let mpartid = question.hasOwnProperty("multiPartId")
          ? question["multiPartId"]
          : "";
        let reftype = question.hasOwnProperty("refType")
          ? question["refType"]
          : "";
        let edited = question.hasOwnProperty("edited") ? question["edited"] : 0;
        //let parts   = ( question.hasOwnProperty("parts") ? question['parts'] : [] );
        var parts = [];
        if (question.hasOwnProperty("parts")) {
          question.parts.forEach((partQuestion) => {
            let quesparts = {};
            quesparts["tid"] = partQuestion["ezid"];
            quesparts["qid"] = partQuestion["qid"];
            quesparts["algo"] = partQuestion["algo"];
            quesparts["types"] = partQuestion["type"];
            quesparts["points"] = partQuestion["points"];
            quesparts["pinned"] = partQuestion["pinned"];
            quesparts["edited"] = partQuestion["edited"];
            quesparts["multiPartId"] = partQuestion["multiPartId"];
            quesparts["refType"] = partQuestion["refType"];
            quesparts["qTitle"] = partQuestion["title"];
            quesparts["bankName"] = this.shareDataService.getBankName();
            parts.push(quesparts);
          });
        }

        let updatedQuestion = new References(
          question["ezid"],
          question["qid"],
          question["algo"],
          question["type"],
          question["points"],
          question["pinned"],
          question["title"],
          this.shareDataService.getBankName(),
          mpartid,
          reftype,
          parts,
          edited
        );

        if (question["isbn"] === undefined || question["isbn"] == "") {
          updatedQuestion.setIsbn(isbn);
        } else {
          updatedQuestion.setIsbn(question["isbn"]);
        }
        referencesArr.push(updatedQuestion);
        if (updatedQuestion.getAlgo() && !algoPresent) {
          algoPresent = true;
        }
      });
      this.collection.setReferences(referencesArr);
    } else {
      this.collection.setClearedQuestion(true);
    }
    this.shareDataService.setCollectionDetails(this.collection);
    this.shareDataService.setCollectionSubject(this.collection);
    this.shareDataService.setAlgoPresent(algoPresent);
    return this.collection;
  }

  public setCollectionInfoInHeader(skipAnnouncement: boolean = false) {
    let totalPoints = 0,
      questionLength = 0;
    if (this.selectedQuestionsListObj) {
      const questionsList = this.selectedQuestionsListObj;
      if (questionsList && questionsList.length > 0) {
        let totalPoints = 0;

        for (const question of questionsList) {
          if (question.hasOwnProperty("parts")) {
            var totalPointsPart = 0;
            for (const partsPoints of question.parts) {
              totalPointsPart += +partsPoints.points;
            }

            totalPoints += totalPointsPart;
          } else {
            totalPoints += +question.points;
          }
        }
        let questionCount = 0;
        questionsList.map((value) => {
          if (!value.hasOwnProperty("parts")) {
            questionCount++;
          }
          if (value?.parts && value?.parts.length > 0) {
            value?.parts.map(() => {
              questionCount++;
            });
          }
        });

        // Store current values
        const currentQuestions = questionCount;
        const currentPoints = parseFloat(totalPoints.toFixed(2));
        // Announce both values together if either changed (more reliable for VoiceOver on Mac)
        const questionsChanged = this.previousTotalQuestions !== currentQuestions;
        const pointsChanged = this.previousTotalPoints !== currentPoints;
        if (!this.isComponentInitializing && !skipAnnouncement && (questionsChanged || pointsChanged)) {
          const announcement = questionsChanged ? `Total questions ${currentQuestions}, Total points ${currentPoints}` : `Total points ${currentPoints}`;
          this.queueLiveAnnouncement(announcement, 'polite', this.successAlertDuration, 5500);
        }
        this.previousTotalQuestions = currentQuestions;
        this.previousTotalPoints = currentPoints;
        this.headerData.setTotalPoints(totalPoints.toFixed(2));
        this.headerData.setTotalQuestions(questionCount);
        this.shareDataService.setHeaderData(this.headerData);
        this.totalQuestionCount = questionCount;
      } else {
        // Handle empty list case
        const questionsChanged = this.previousTotalQuestions !== questionLength;
        const pointsChanged = this.previousTotalPoints !== totalPoints;
        if (!this.isComponentInitializing && !skipAnnouncement && (questionsChanged || pointsChanged)) {
          const announcement = questionsChanged ? `Total questions ${questionLength}, Total points ${totalPoints}` : `Total points ${totalPoints}`;
          this.queueLiveAnnouncement(announcement, 'polite', this.successAlertDuration, 5500);
        }
        this.previousTotalQuestions = questionLength;
        this.previousTotalPoints = totalPoints;
        this.headerData.setTotalPoints(totalPoints);
        this.headerData.setTotalQuestions(questionLength);
        this.totalQuestionCount = questionLength;
        this.shareDataService.setHeaderData(this.headerData);
      }
      return this.headerData;
    }
  }

  public arrayPinnedQuestions() {
    this.pinnedQuestionListIndex = [];
    this.pinnedQuestionList = [];
    this.selectedQuestionsListObj = this.selectedQuestionsListObj.map(
      (item) => {
        const index = this.selectedQuestionsListObj.indexOf(item);
        if (item.pinned) {
          this.pinnedQuestionListIndex.push(index);
          this.pinnedQuestionList.push(item);
        }
        return item;
      }
    );
    this.createCollectionObject();
  }

  public assignArrayIndex(skipAnnouncement: boolean = false) {
    const list = [];
    this.selectedQuestionsListObj = this.selectedQuestionsListObj.map(
      (item, ind) => {
        item.index = ind;
        item.previewIndex = item.index;
        this.questionIdArray.push(item.qid);
        if (list.indexOf(item.qid) === -1) {
          list.push(item.qid);
        }
        this.shareDataService.setDroppedQuestionId(list);
        return item;
      }
    );
    // Share data to footer component for save and exit
    this.createCollectionObject();
    this.setCollectionInfoInHeader(skipAnnouncement);
  }

  public pointsChanged(event, skipAnnouncement: boolean = false) {
    // reset all the index value after one/multiple objects inserted in between array when input value changed
    this.arrayIndex = 0;
    this.questionIdArray = [];
    this.assignArrayIndex(skipAnnouncement);
  }

  drop(event: CdkDragDrop<any[]>) {
    // do not allow drop outside drop zone
    if (!event.isPointerOverContainer) {
      return;
    }
    // reorder within the SAME container
    if (event.previousContainer === event.container) {
      // Convert page-relative indices to absolute indices in the full dataset
      const absolutePreviousIndex = (this.currentPageIndex * this.pageSize) + event.previousIndex;
      const absoluteCurrentIndex = (this.currentPageIndex * this.pageSize) + event.currentIndex;
      
      // Validate that the absolute indices are within bounds
      if (absolutePreviousIndex >= 0 && absolutePreviousIndex < event.container.data.length &&
          absoluteCurrentIndex >= 0 && absoluteCurrentIndex < event.container.data.length) {
        moveItemInArray(
          event.container.data,
          absolutePreviousIndex,
          absoluteCurrentIndex
        );
        this.reorderList();
      }
    }
    // copy from LEFT to RIGHT
    else if (
      event.previousContainer.id === 'leftList' &&
      event.container.id === 'test-panel'
    ) {
      if (!this.sourceBank) {
        return; // Prevent drag operation if sourceBank is not available
      }
      // Get the full dataset and calculate absolute index
      const fullDataset = this.sourceBank.getParsedArray();
      const absoluteIndex = (this.sourceBank.currentPageIndex * this.sourceBank.pageSize) + event.previousIndex;
      // Get the item being dragged from the full dataset using absolute index
      if (absoluteIndex >= 0 && absoluteIndex < fullDataset.length) {
        const draggedItem = fullDataset[absoluteIndex];
        if (draggedItem) {
          const newItem = structuredClone(draggedItem);
          newItem.selected = false;
          let randomNumber = Math.random().toString().substring(2);
          newItem.uniqueId = `${newItem.qid}-${randomNumber}`;
          if (newItem.parts) {
            newItem.parts.forEach(part => {
              part.selected = false;
              part.parentUniqueId = newItem.uniqueId;
              part.uniqueId = `${part.qid}-${randomNumber}`;
            });
          }
          // Push the cloned item to the end of the right list
          event.container.data.push(newItem);
          this.transferDataSuccess();
        }
      }
    }
  }

  // Handle drag enter event into right container
  onDragEnter(event: CdkDragEnter) {
    if (event.item.dropContainer.id === 'leftList') {
      // Handle drag enter for left list hide preview in right container
      const dragPlaceholderElem = document.getElementsByClassName('cdk-drag-placeholder');
      if (dragPlaceholderElem?.length > 0) {
        const placeholder = dragPlaceholderElem[0] as HTMLElement;
        placeholder.classList.add('opacity-0');
      }
    }
  }

  // Reorder list after drag and drop within right container
  private reorderList() {
    this.shareDataService.sendSpinnerData(false);
    this.questionIdArray = [];
    this.assignArrayIndex();
    this.arrayPinnedQuestions();
    this.shareDataService.setSelectedQuestionList(
      this.selectedQuestionsListObj
    );
    this.assignSelectedQuestionArray();
    this.shareDataService.sendSpinnerData(true);
    this.assignArrayIndexSectionBreakQuestion(this.selectedQuestionsListObj);
    this.dataChanged();
  }

  transferDataSuccess() {
    this.shareDataService.sendSpinnerData(false);
    // reset all the index value after one/multiple objects inserted in between array

    this.questionIdArray = [];
    this.assignArrayIndex();
    this.arrayPinnedQuestions();
    this.shareDataService.setSelectedQuestionList(
      this.selectedQuestionsListObj
    );
    this.assignSelectedQuestionArray();
    this.shareDataService.sendSpinnerData(true);
    this.assignArrayIndexSectionBreakQuestion(this.selectedQuestionsListObj);
    this.suppressAnnouncement = false;
    this.showSuccessAlert(ADD_SUCCESS_MSG_SINGLE_QUESTION);
    this.dataChanged();
    this.enableAdd = 0;
    this.updateSelectAllCheckboxState();
  }

  // Add question to right panel temporary preview for keyboard shortcuts
  addToRightTemp(selectedQuestions?): void {
    const previousTempAddedQuestion = this.tempAddedQuestion;
    this.tempAddedQuestion = selectedQuestions && selectedQuestions.length > 0 ? selectedQuestions[0] : null;
    this.tempAddRemoveMessage = this.tempAddedQuestion ?
    `Question ${this.tempAddedQuestion.title} marked for adding to test. Press Enter/Space to confirm or Escape to cancel.` :
    `Cancelled adding question ${previousTempAddedQuestion.title} to test.`;
    if (selectedQuestions && selectedQuestions.length > 0) {
      const dropZone = this.selectedQuestionsListObj.length > 0 ? this.dropZoneWithQuestion : this.dropZoneKeyboard;
      dropZone.nativeElement.classList.add('drop-zone-highlight');
    } else {
      this.removeDropZoneHighlight();
    }
    this.cdr.detectChanges();
    this.tempAddedQuestionContainer?.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  addToRight = function (event, selectedQuestion?, isKebabAction = false) {
    this.shareDataService.sendSpinnerData(false);
    let addQuestionsList = [];
    let changeFocus = true;
    if (selectedQuestion) {
      addQuestionsList = JSON.parse(JSON.stringify(selectedQuestion));
    } else {
      addQuestionsList = JSON.parse(
        JSON.stringify(this.shareDataService.getSelectedQuestions())
      );
      
      // If search filter is active, only add items that match the filter
      if (this.textSearchLeft?.trim() !== '') {
        addQuestionsList = addQuestionsList.filter(question => 
          question.title.toLowerCase().includes(this.textSearchLeft.toLowerCase()) ||
          question.preview.toLowerCase().includes(this.textSearchLeft.toLowerCase())
        );
      }
      
      //apply filter if filter is applied
      addQuestionsList = this.questionListPipe.transform(
        addQuestionsList,
        this.filterJsonObject,
        true
      );
    }

    addQuestionsList.forEach((item) => {
      if (item.selected) {
        //To remove selection while added to right
        item.selected = false;
      }
      //item.index = this.arrayIndex++;
      let randomNumber = Math.random().toString().substring(2);
      item.uniqueId = item.qid + "-" + randomNumber;
      if (item.hasOwnProperty("parts")) {
        item.parts = item.parts.map((partQuestion, pindex) => {
          if (partQuestion.selected) {
            //To remove selection while added to right
            partQuestion.selected = false;
          }
          partQuestion.uniqueId = partQuestion.qid + "-" + randomNumber;
          partQuestion.parentUniqueId = item.uniqueId;
          return partQuestion;
        });
      }
    });
    // Reset pagination to page 1 if adding to empty list
    const wasEmpty = this.selectedQuestionsListObj.length === 0;
    
    this.selectedQuestionsListObj.push(...addQuestionsList);

    // Reset pagination if we added to an empty list
    if (wasEmpty && addQuestionsList.length > 0) {
      this.currentPageIndex = 0;
    }

    // reset all the index value after one/multiple objects inserted in between array

    this.questionIdArray = [];
    this.assignArrayIndex();
    this.assignArrayIndexSectionBreakQuestion(this.selectedQuestionsListObj);
    this.arrayPinnedQuestions();

    // Clear array after adding to right

    this.setKebabPreviewIndex();
    if (this.selectedQuestionsListObjStore?.length > 0) {
      this.selectedQuestionsListObjStore.push(...addQuestionsList);
    }

    setTimeout(() => {
      this.pointsAlignment();
    }, 100);
    this.shareDataService.sendSpinnerData(true);
    this.assignSelectedQuestionArray();
    const successMsg = addQuestionsList.length === 1 ? ADD_SUCCESS_MSG_SINGLE_QUESTION : ADD_SUCCESS_MSG_MULTIPLE_QUESTIONS;
    this.suppressAnnouncement = false;
    // adding delay to allow time for DOM updates before announcing success message
    setTimeout(() => this.showSuccessAlert(successMsg), 500);
    this.dataChanged();
    this.enableAdd = 0;
    if (this.tempAddedQuestion) {
      this.tempAddedQuestion = null;
      changeFocus = false;
    }
    this.tempAddRemoveMessage = '';
    this.removeDropZoneHighlight();
    if (this.sourceBankComponent && changeFocus && !isKebabAction) {
      this.sourceBankComponent.focusSelectAllCheckbox();
      this.addToTestAnnouncement = `${this.selectedQuestionsListObj.length} question${this.selectedQuestionsListObj.length === 1 ? '' : 's'} added to your test.`;
    }
    this.updateSelectAllCheckboxState();
    // This ensures that users are informed when the "Add to Test" button becomes disabled after adding questions
    this.queueLiveAnnouncement('Add to Test button disabled.', 'polite', this.successAlertDuration, this.removalAnnouncementDelay);
  };
 
  /**
   * Removes the 'drop-zone-highlight' CSS class from all drop zone elements.
   * This method ensures that any visual highlight applied to the drop zones
   * (with or without questions, or for keyboard interaction) is cleared.
   */
  private removeDropZoneHighlight() {
    this.dropZoneWithQuestion?.nativeElement?.classList.remove('drop-zone-highlight');
    this.dropZoneKeyboard?.nativeElement?.classList.remove('drop-zone-highlight');
    this.dropZoneNoQuestion?.nativeElement?.classList.remove('drop-zone-highlight');
  }

  currentPage(dataArray) {
    const collectionArray = {};
    let pageNum = 0;
    for (let i = 0; i < dataArray.length; i += this.pageSize) {
      const chunk = dataArray.slice(i, i + this.pageSize);
      collectionArray[pageNum] = chunk;
      pageNum++;
    }
    this.totalLength = dataArray.length;
    this.questionCollection = { ...collectionArray };
  }
  get currentData() {
    this.dataChanged();
    return this.questionCollection[this.currentPageIndex] || [];
  }
  fetchPage(event: PageEvent) {
    this.currentPageIndex = event.pageIndex;
    this.firstItemIndex = event.firstItemIndex;
    this.scrollQuestionListToTop();
    if (!!this.questionCollection[this.currentPageIndex]) {
      return;
    }
  }

  private scrollQuestionListToTop() {
    this.dropZoneWithQuestion?.nativeElement?.scrollTo({
      top: 0,
      left: 0,
      behavior: 'auto'
    });
  }

  OnCheckboxSelect(
    bank,
    event,
    qtype,
    dependent = false,
    parentQuestion,
    partindex
  ) {
    var that = this;
    var index = -1;
    let leng = this.selectedQuestionsList.length;
    for (let i = 0; i < leng; i++) {
      if (this.selectedQuestionsList[i].uniqueId == bank.uniqueId) {
        index = i;
        break;
      }
    }
    if (qtype == "part" && dependent === true) {
      var objIndex = this.selectedQuestionsListObj.indexOf(parentQuestion);
      let partQues = bank;
      bank = parentQuestion;
      bank.parts[partindex].selected = event;
      index = this.selectedQuestionsList.indexOf(bank);
      if (index === -1) {
        this.selectedQuestionsList.push(bank);
      } else {
        this.selectedQuestionsList[index] = bank;
      }
      var totalPartQuestion = bank.parts.length;
      if (totalPartQuestion == 1) {
        // If only one part question is present then parent question will be selected.
        if (event) {
          bank.selected = true;
          this.selectedQuestionsListObj[objIndex].selected = true;
        } else {
          this.selectedQuestionsListObj[objIndex].selected = false;
          bank.selected = false;
          if (index !== -1) {
            this.selectedQuestionsList.splice(index, 1);
          }
        }
      } else {
        // This will select/unselect the parent checkbox depending upon the child selection. if all child selected then parent will be selected automatically same as vice versa
        var checkedQuestion = 0;
        bank.parts.forEach((subpa) => {
          if (subpa.selected === true) {
            checkedQuestion++;
          }
        });
        if (totalPartQuestion == checkedQuestion) {
          bank.selected = true;
          this.selectedQuestionsListObj[objIndex].selected = true;
        } else {
          bank.selected = false;
          this.selectedQuestionsListObj[objIndex].selected = false;
          if (checkedQuestion == 0 && index !== -1) {
            // This is the last uncheck part question. So parent sb question will remove from seleted question list
            this.selectedQuestionsList.splice(index, 1);
          }
        }
      }
      this.computeSectionBreakAriaChecked(parentQuestion);
      this.updateSectionBreakCheckboxIndeterminate(parentQuestion);
    } else if (qtype == "multipart") {
      bank.selected = event;
      index = this.selectedQuestionsList.indexOf(bank);
      if (index === -1) {
        this.selectedQuestionsList.push(bank);
      } else {
        this.selectedQuestionsList[index] = bank;
      }
      // For All child selection ..
      var objIndex = this.selectedQuestionsListObj.indexOf(bank);
      if (event) {
        this.selectedQuestionsListObj[objIndex].parts.forEach((subparts) => {
          subparts.selected = true;
        });
      } else {
        this.selectedQuestionsListObj[objIndex].parts.forEach((subparts) => {
          subparts.selected = false;
        });
        if (index !== -1) {
          this.selectedQuestionsList.splice(index, 1);
        }
      }
      this.computeSectionBreakAriaChecked(bank);
      this.updateSectionBreakCheckboxIndeterminate(bank);
    } else {
      if (event) {
        if (index === -1) {
          bank.selected = true;
          this.selectedQuestionsList.push(bank);
        }
      } else {
        if (index !== -1) {
          bank.selected = false;
          this.selectedQuestionsList.splice(index, 1);
        }
      }
    }

    that.renameActivated = this.selectedQuestionsList.length > 0 ? false : true;
    this.updateSelectAllCheckboxState();
  }

  private updateSelectAllCheckboxState(): void {
    if (!this.selectAllCheckboxRef) {
      return;
    }

    let filteredQuestions = this.selectedQuestionsListObj;
    if (this.searchedTextRight?.trim() !== '') {
      filteredQuestions = this.filterSearchedItem(this.selectedQuestionsListObj);
    }

    if (filteredQuestions.length === 0) {
      this.setSelectAllState(false, false);
      return;
    }

    let totalCount = 0;
    let selectedCount = 0;

    filteredQuestions.forEach(question => {
      if (question.parts?.length > 0) {
        totalCount++;
        if (question.selected === true) {
          selectedCount++;
        }
        question.parts.forEach(part => {
          totalCount++;
          if (part.selected === true) {
            selectedCount++;
          }
        });
      } else {
        totalCount++;
        if (question.selected === true) {
          selectedCount++;
        }
      }
    });

    if (selectedCount === 0) {
      this.setSelectAllState(false, false);
    } else if (selectedCount === totalCount) {
      this.setSelectAllState(true, false);
    } else {
      this.setSelectAllState(false, true);
    }
  }

  private setSelectAllState(checked: boolean, indeterminate: boolean): void {
    this.selectedTitle.selected = checked;
    if (this.selectAllCheckboxRef) {
      this.selectAllCheckboxRef.indeterminate = indeterminate;
    }
  }

  // Add getter for aria-checked
  public get selectAllAriaCheckedRight(): 'true' | 'false' | 'mixed' {
    if (!this.selectAllCheckboxRef) {
      return 'false';
    }
    if (this.selectAllCheckboxRef.indeterminate) {
      return 'mixed';
    }
    return this.selectedTitle.selected ? 'true' : 'false';
  }

  private computeSectionBreakAriaChecked(question: any): void {
    if (!question?.parts || !Array.isArray(question.parts)) {
      question.ariaChecked = 'false';
      return;
    }
    if (question.parts.some(part => part.selected)) {
      question.ariaChecked = question.parts.every(part => part.selected) ? 'true' : 'mixed';
    } else {
      question.ariaChecked = 'false';
    }
  }

  public updateSectionBreakCheckboxIndeterminate(parentQuestion: any): void {
    if (!parentQuestion?.parts || !Array.isArray(parentQuestion.parts)) {
      return;
    }

    const currentPageArray = this.questionCollection[this.currentPageIndex] || [];
    const questionIndex = currentPageArray.findIndex(q => q.uniqueId === parentQuestion.uniqueId);

    if (questionIndex === -1 || !this.questionCheckboxes) {
      return;
    }

    const checkboxArray = this.questionCheckboxes.toArray();
    if (questionIndex >= checkboxArray.length || !checkboxArray[questionIndex]) {
      return;
    }

    const somePartsSelected = parentQuestion.parts.some(part => part.selected);
    const allPartsSelected = parentQuestion.parts.every(part => part.selected);

    checkboxArray[questionIndex].indeterminate = somePartsSelected && !allPartsSelected;
  }

  pinUnpinQuestion(obj) {
    if (this.selectedQuestionsListObj[obj.index].pinned != undefined) {
      this.selectedQuestionsListObj[obj.index].pinned =
        !this.selectedQuestionsListObj[obj.index].pinned;
    }
    this.createCollectionObject();
    this.arrayPinnedQuestions();
  }

  sortOnlyUnpinned(event) {
    if (event != undefined) {
      this.selectedQuestionsListObj = event;
      for (
        let questions = 0;
        questions < this.selectedQuestionsListObj.length;
        questions++
      ) {
        if (this.selectedQuestionsListObj[questions].pinned) {
          this.selectedQuestionsListObj.splice(questions, 1);
          questions--;
        }
      }
      //insert pinned one to designated pre determined position
      for (
        let pinnedArray = 0;
        pinnedArray < this.pinnedQuestionListIndex.length;
        pinnedArray++
      ) {
        this.selectedQuestionsListObj.splice(
          this.pinnedQuestionListIndex[pinnedArray],
          0,
          this.pinnedQuestionList[pinnedArray]
        );
      }
      // reset all the index value after one/multiple objects inserted in between array

      this.questionIdArray = [];
      this.assignArrayIndex();
    }
  }

  selectAllSelctedSource(event) {
    var that = this;
    this.selectAllCheckboxRef.indeterminate = false;
    if (event) {
      this.selectedTitle = { selected: true };
    } else {
      this.selectedTitle = { selected: false };
    }
    this.selectedQuestionsListObj.forEach((item) => {
      item.selected = event;

      if (item.hasOwnProperty("parts")) {
        item.parts = item.parts.map((partQuestion) => {
          partQuestion.selected = event;
          return partQuestion;
        });
        this.computeSectionBreakAriaChecked(item);
      }

      // if (item.selected && this.selectedQuestionsList.indexOf(item) === -1) {
      if (item.selected) {
        this.selectedQuestionsList.push(item);
      } else if (!item.selected) {
        this.selectedQuestionsList = [];
      }
    });
    that.renameActivated = this.selectedQuestionsList.length > 0 ? false : true;
    this.questionCheckboxes?.forEach(checkbox => {
      checkbox.indeterminate = false;
    });
  }

  private getEditData() {
    this.getBankDetails();
    if (this.shareDataService.getLandingState() == "zero-state") {
      this.selectedQuestionsListObj = [];
    }
    if (this.shareDataService.getLandingState() == "edit-state") {
      if (
        this.shareDataService.getCollectionObjectDetails() != undefined ||
        this.shareDataService.getCollectionObjectDetails() != null
      ) {
        this.selectedQuestionsListObj =
          this.shareDataService.getCollectionObjectDetails().references;
        this.selectedQuestionsListObj.forEach((item) => {
          let randomNumber = Math.random().toString().substring(2);
          item.uniqueId = item.qid + "-" + randomNumber;
          if (item.hasOwnProperty("parts")) {
            item.parts = item.parts.map((partQuestion) => {
              partQuestion.uniqueId = partQuestion.qid + "-" + randomNumber;
              partQuestion.parentUniqueId = item.uniqueId;
              return partQuestion;
            });
          }
        });
        this.selectedQuestionsListObjStore = JSON.parse(
          JSON.stringify(this.selectedQuestionsListObj)
        );
      }
    }
    // reset all the index value after one/multiple objects inserted in between array

    this.questionIdArray = [];
    this.assignArrayIndex();
    this.assignArrayIndexSectionBreakQuestion(this.selectedQuestionsListObj);
    this.arrayPinnedQuestions();
    this.createCollectionObject();
    this.assignSelectedQuestionArray();
  }

  public trackByIndex(index, item) {
    return index;
  }
  checkQuestionLoad(event) {
    this.showBank = event;
    this.cdr.detectChanges();
    if (!this.showBank) {
      if (this.changeSourceButton) {
        this.changeSourceButton.focus();
      }
    }
  }
  getData() {
    this.questionList = "Example";
  }

  getBankDetails() {
    this.shareDataService.getBankObject().subscribe(
      (data) => {
        this.bankObj = data;
      },
      (error) => {
        console.log("in error of getBankDetails : ", error);
      }
    );
  }

  @HostListener("window:resize", ["$event"])
  onResize(event?) {
    this.screenHeight = window.innerHeight;
    this.screenWidth = window.innerWidth;
    /**set source picker component height */
    this.sourcePickerCompHeight = this.screenHeight - this.sourcePickerVerticalOffset;
    this.sourcePickerDestiHeight = this.screenWidth > MEDIUM_SCREEN_BREAKPOINT_PX && this.screenHeight > MEDIUM_SCREEN_HEIGHT_BREAKPOINT_PX
      ? this.screenHeight - LARGE_VIEW_HEIGHT_OFFSET_BODY - FOOTER_OFFSET_HEIGHT
      : this.screenHeight - SMALL_VIEW_HEIGHT_OFFSET_BODY - FOOTER_OFFSET_HEIGHT;
    this.sourcePickerTableCompHeight = this.screenHeight - this.sourcePickerTableVerticalOffset;
    this.showFilterBtnTooltip = this.screenWidth < SMALL_SCREEN_BREAKPOINT_PX;
    this.setTruncateLength();
    this.showHideMulQuestionKebab();
  }
  ngAfterViewInit() {
    this.onResize();
    this.cdr.detectChanges();
  }
  ngAfterContentChecked() {
    this.cdr.detectChanges();
  }
  OpenPanel(section, index, item, event, question) {
    this.child.openMainPanel(event.target, question);
  }

  receiveMessage($event) {
    this.count = $event;
  }

  receiveFilter($event) {
    this.filterJsonObject = JSON.parse(JSON.stringify($event));
  }

  modalOptOut($event) {
    this.modalShow = false;
  }

  removeSelected() {
    if (!this.modalShow) {
      this.modalOkJob();
    } else {
      this.showModal = true;
    }
  }
  setRemoveSelected(event) {
    this.modalShow = !event;
  }
  executePartQuestionRemove(params) {
    let parentIndex: number | null = null;
    let removedPartIndex: number | null = null;
    let wasParentDeleted = false;
    
    this.selectedQuestionsListObj.forEach((item, mainIndex) => {
      let sbindex;

      if (params.parentUniqueId == item.uniqueId) {
        sbindex = item.index;
        parentIndex = mainIndex;
        const pIndex = this.selectedQuestionsListObj[mainIndex].parts.find(
          (x) => x.qid == params.qid
        );

        if (!pIndex) return;

        removedPartIndex = pIndex.index;
        this.selectedQuestionsListObj[mainIndex].parts.splice(pIndex.index, 1);
        //this.selectedQuestionsListObj[sbindex].parts.splice(index, 1);
        this.selectedQuestionArray.delete(params.qid + "-parts");

        if (item.parts.length == 0) {
          // If no question present under the section break then delete the section break
          this.selectedQuestionsListObj.splice(sbindex, 1);
          this.arrayIndex = 0;
          this.questionIdArray = [];
          wasParentDeleted = true;

          this.showSectionBreakQuestionDeleteModal = false;
          this.selectedQuestionArray.delete(item.qid + "-main");
        }
        this.partQuestionRemove = false;
      }
    });

    this.assignArrayIndex();
    this.assignArrayIndexSectionBreakQuestion(this.selectedQuestionsListObj);
    this.setKebabPreviewIndex();
    this.validatePaginationState();
    this.suppressAnnouncement = true;
    this.showSuccessAlert(REMOVE_SUCCESS_MSG_SINGLE_QUESTION);
   
    const focusTarget = this.calculateFocusIndexForPartRemoval(parentIndex, removedPartIndex, wasParentDeleted);    
    if (focusTarget.index === -1) {
      this.focusCreateQuestion();
    } else if (focusTarget.isPartQuestion) {
      this.focusOnPartCheckbox(focusTarget.index);
    } else {
      this.focusCheckboxOrCreateQuestion(focusTarget.index);
    }
    
    this.queueLiveAnnouncement(REMOVE_SUCCESS_MSG_SINGLE_QUESTION, 'polite', this.successAlertDuration, this.removalAnnouncementDelay);
    this.updateExpandToggleButtonState();
    this.updateSelectAllCheckboxState();
  }

  
  private calculateFocusIndexForPartRemoval(parentIndex, removedPartIndex, wasParentDeleted): { isPartQuestion: boolean, index: number } {
    if (parentIndex === null || removedPartIndex === null) {
      return { isPartQuestion: false, index: -1 };
    }
    
    if (wasParentDeleted) {
      const totalQuestions = this.selectedQuestionsListObj.length;
      if (totalQuestions === 0) {
        return { isPartQuestion: false, index: -1 };
      } else if (parentIndex >= totalQuestions) {
        return { isPartQuestion: false, index: totalQuestions - 1 };
      } else {
        return { isPartQuestion: false, index: parentIndex };
      }
    } else {
      const remainingPartsCount = this.selectedQuestionsListObj[parentIndex]?.parts?.length ?? 0;      
      if (remainingPartsCount === 0) {
        return { isPartQuestion: false, index: parentIndex };
      } else {
        const targetPartIndex = removedPartIndex >= remainingPartsCount ? remainingPartsCount - 1 : removedPartIndex;
        const partCheckboxIndex = this.calculatePartCheckboxIndex(parentIndex, targetPartIndex);
        return { isPartQuestion: true, index: partCheckboxIndex };
      }
    }
  }
  
  private calculatePartCheckboxIndex(parentIndex: number, targetPartIndex: number): number {
    let index = 0;
    for (let i = 0; i < parentIndex && i < this.selectedQuestionsListObj.length; i++) {
      if (this.selectedQuestionsListObj[i].parts) {
        index += this.selectedQuestionsListObj[i].parts.length;
      }
    }
    index += targetPartIndex;    
    return index;
  }
  
  private focusOnPartCheckbox(index: number): void {
    this.cdr.detectChanges();
    const partCheckboxToFocus = this.partCheckboxes.get(index);
    if (partCheckboxToFocus) {
      partCheckboxToFocus.focus();
    } else {
      this.focusCheckboxOrCreateQuestion(0);
    }
  }

  softSourceDelete(obj) {
    if (obj.refType == "multipart") {
      this.sectionBreakRemoveObj = obj;
      this.DeleteModalHeader = "Delete Section Break";
      this.deleteMessage = "msg1";
      this.secBreakRemove = true;
      this.toggleAddRemoveButtonPreviewModal(obj, false);
      this.storeKebabButtonForFocus(obj);
      this.showSectionBreakQuestionDeleteModal = true;
    } else if (
      obj.refType == "scalar" &&
      obj.hasOwnProperty("multiPartId") &&
      obj.multiPartId != ""
    ) {
      //this.partQuestionRemove = true
      //this.deleteMessage = 'Removing the section break will remove all of its parts.'
      let noOfPartQuestion;
      this.selectedQuestionsListObj.forEach((item) => {
        if (obj.multiPartId == item.multiPartId) {
          noOfPartQuestion = item.parts?.length ?? 0;
        }
      });

      if (noOfPartQuestion == 1) {
        this.storeKebabButtonForFocus(obj);
        this.showSectionBreakQuestionDeleteModal = true;
        this.partQuestionRemove = true;
        this.secBreakRemove = false;
        this.sectionPartsRemoveObj = obj;
        this.DeleteModalHeader = "Delete Question";
        this.deleteMessage = "msg2";
        this.toggleAddRemoveButtonPreviewModal(obj, false);
      } else {
        this.executePartQuestionRemove(obj);
      }
    } else {
      this.executeSoftSourceDelete(obj);
    }
  }

  executeSoftSourceDelete(obj) {
    // delete from selected question list
    if (this.selectedQuestionsList?.length > 0) {
      let selectedQuestionsListLength = this.selectedQuestionsList.length - 1;
      for (let i = 0; i <= selectedQuestionsListLength; i++) {
        if (this.selectedQuestionsList[i].qid == obj.qid) {
          this.selectedQuestionsList.splice(i, 1);
          break;
        }
      }
    }
    // delete from right hand panel
    this.selectedQuestionsListObj.forEach((item) => {
      if (obj.uniqueId == item.uniqueId) {
        const index = this.selectedQuestionsListObj.indexOf(item);
        this.selectedQuestionsListObj.splice(index, 1);
        this.shareDataService.setDeletedQuestionId(item);
        // reset all the index value after one/multiple objects inserted in between array
        this.selectedQuestionArray.delete(item.qid + "-main");
        // If multipart question, delete all part entries
        if (item.refType === "multipart" && item.hasOwnProperty("parts")) {
          item.parts.forEach((partQuestion) => {
            this.selectedQuestionArray.delete(partQuestion.qid + "-parts");
          });
        }
        this.questionIdArray = [];
        this.assignArrayIndex();
        this.assignArrayIndexSectionBreakQuestion(
          this.selectedQuestionsListObj
        );
      }
    });
    this.showSectionBreakQuestionDeleteModal = false;
    this.setKebabPreviewIndex();
    this.validatePaginationState();
    this.suppressAnnouncement = true;
    this.showSuccessAlert(REMOVE_SUCCESS_MSG_SINGLE_QUESTION);
    this.focusCheckboxOrCreateQuestion(this.selectedQuestionsListObj.length === obj?.index ? obj?.index - 1 : obj?.index);
    this.queueLiveAnnouncement(REMOVE_SUCCESS_MSG_SINGLE_QUESTION, 'polite', this.successAlertDuration, this.removalAnnouncementDelay);
    this.updateExpandToggleButtonState();
    this.updateSelectAllCheckboxState();
  }

  public getOnlinePreviewUrl(clickedItem) {
    let selectedObject = false;

    this.selectedQuestionsListObj.map((item) => {
      if (item.selected == true && item.qid == clickedItem.qid)
        selectedObject = true;

      if (item?.parts) {
        item.parts.map((item) => {
          if (item.selected == true && item.qid == clickedItem.qid)
            selectedObject = true;
        });
      }
    });
    if (selectedObject) {
      this.previewTestQuestions();
      this.previewQuestionsList.map((x, index) => {
        if (x.uniqueId == clickedItem.uniqueId) this.qIndex = index;
      });
    } else {
      this.isPreviewTestQuestions = true;
      this.pushPartQuestionPreviewQuestionsList();
      this.setPreviewQuestionIndex();
      this.qIndex = this.previewQuestionsList.find(
        (x) => x.uniqueId == clickedItem.uniqueId
      ).previewIndex;
    }
  }
  public closeModal(obj) {
    this.isPreviewTestQuestions = !obj;
    this.isPreviewSourceQuestions = !obj;
    this.closeModalPopUp = !obj;
    this.previewHeaderText = "Previewing all questions";
    this.questionIndex = "0";
    this.resetQuestionPoistion();
    this.previewQuestionsList = [];
  }

  resetQuestionPoistion() {
    let freshSelectedQuestionsList = [];
    if (this.selectedQuestionsListObjStore?.length > 0) {
      this.selectedQuestionsListObjStore.forEach((itm) => {
        this.selectedQuestionsListObj.find((item) => {
          if (itm.uniqueId == item.uniqueId) {
            if (itm.hasOwnProperty("parts")) {
              let subparts = [];
              let partIndex = 0;
              itm.parts.forEach((pitm) => {
                let partsFound = 0;
                item.parts.find((pitem) => {
                  if (pitm.qid == pitem.qid) {
                    partsFound = 1;
                  }
                });
                if (partsFound == 1) {
                  pitm.index = partIndex++;
                  subparts.push(pitm);
                  partsFound = 0;
                }
              });
              itm.parts = subparts;
            }
            freshSelectedQuestionsList.push(itm);
          }
        });
      });
      this.selectedQuestionsListObj = JSON.parse(
        JSON.stringify(freshSelectedQuestionsList)
      );
    }

    freshSelectedQuestionsList = [];
    this.createCollectionObject();
  }

  // Remove array of data from right hand panel
  removeFromArray(original, remove) {
    return original.filter((value) => !remove.includes(value));
  }

  modalOkJob(selectedQuestion?) {
    var that = this;
    // this.selectedQuestionsListObj = this.removeFromArray(this.selectedQuestionsListObj, this.selectedQuestionsList);
    if (selectedQuestion) {
      this.selectedQuestionsList = selectedQuestion;
    }
    let alertMsg = this.selectedQuestionsList.length > 1 ? REMOVE_SUCCESS_MSG_MULTIPLE_QUESTIONS : REMOVE_SUCCESS_MSG_SINGLE_QUESTION;
    this.selectedQuestionsList.forEach((itm) => {
      let ind = this.selectedQuestionsListObj.indexOf(itm);
      if (selectedQuestion) {
        this.selectedQuestionsListObj.map((item, index) => {
          if (item.qid == itm.qid) {
            itm.selected = true;
            ind = index;
          }
        });
      }
      if (itm.selected === true) {
        // scalar question or multipart question remove which is selected true
        if (ind > -1) {
          this.selectedQuestionsListObj.splice(ind, 1);
        }
      } else if (itm.selected === false) {
        // This will delete the part question
        if (itm.hasOwnProperty("parts")) {
          let deletedParts = [];
          itm.parts.forEach((item) => {
            const index = item.index;
            if (item.selected == true) {
              deletedParts.push(item);
            }
          });
          this.selectedQuestionsListObj[ind].parts = this.removeFromArray(
            this.selectedQuestionsListObj[ind].parts,
            deletedParts
          );
          if (deletedParts.length > 1) {
            alertMsg = REMOVE_SUCCESS_MSG_MULTIPLE_QUESTIONS;
          }
        }
      }
    });

    // After deleteing the selection reset the checkbox
    this.selectedQuestionsListObj.forEach((element) => {
      element.selected = false;
      if (element.hasOwnProperty("parts")) {
        for (var i = 0; i < element.parts.length; i++) {
          element.parts[i].selected = false;
        }
      }
    });

    this.questionIdArray = [];
    this.assignArrayIndex();
    this.assignArrayIndexSectionBreakQuestion(this.selectedQuestionsListObj);
    this.setKebabPreviewIndex();
    that.renameActivated = this.selectedQuestionsList.length > 0 ? true : false;
    this.selectedQuestionsList = [];
    this.selectedTitle = { selected: false };
    this.showModal = false;
    this.suppressAnnouncement = true;
    this.validatePaginationState();
    this.dataChanged();
    this.cdr.detectChanges();
    this.pointsAlignment();
    this.showSuccessAlert(alertMsg);
    this.focusSelectAllCheckboxOrCreateQuestion();
    this.queueLiveAnnouncement(alertMsg, 'polite', this.successAlertDuration, this.removalAnnouncementDelay);
    this.updateSelectAllCheckboxState();
  }
  modalCancelJob() {
    this.showModal = false;
  }

  public settingsRouteActivate() {
    if (this.step == "step2") {
      this.step = "step1";
    }
  }

  public validatePoints(event: any) {
    let isValid = true;
    let message = { Message: "Enter a point value between 0.00 and 1000.00" };
    const value = event.target.value;
    if (
      value === undefined ||
      value == "" ||
      value.includes("-") ||
      value.includes("+")
    ) {
      isValid = false;
    } else if (isNaN(value)) {
      isValid = false;
    } else {
      const numVal = parseFloat(value);
      if (numVal > 1000) {
        isValid = false;
      } else if (numVal < 0) {
        isValid = false;
      } else {
        const dotPos = value.indexOf(".");
        if (
          dotPos > -1 &&
          value.substring(dotPos + 1, value.length).length > 2
        ) {
          isValid = false;
          message = {
            Message: "Enter a point value up to two decimal places.",
          };
        }
      }
    }
    const inputEl = event.target as HTMLInputElement;
    if (isValid) {
      this.updatePointsValidationObject.isDisableUpdatePoints = false;
      this.render.removeClass(inputEl, this.updatePointsInvalidInputClass);
      this.render.addClass(inputEl, this.updatePointsValidInputClass);
      this.render.removeAttribute(inputEl, "aria-invalid");
      this.setCollectionInfoInHeader();
      this.updatePointsValidationObject.showInvalidMessage = "";
      this.updatePointsValidationObject.errorMessageAnnouncement = "";
    } else {
      // Relocated outside of the if-else block for HEA-15522
      this.render.removeClass(inputEl, this.updatePointsValidInputClass);
      this.render.addClass(inputEl, this.updatePointsInvalidInputClass);
      this.render.setAttribute(inputEl, "aria-invalid", "true");
      if (this.updatePointsValidationObject.callFromUpdatePoints) {
        // Only announce error if the previous message was different or empty
        const errorMessage = "Error: Enter a point value between 0.00 and 1000.00";
        if (this.updatePointsValidationObject.showInvalidMessage !== errorMessage) {
          this.updatePointsValidationObject.showInvalidMessage = errorMessage;
          // Only announce on actual validation errors, not on focus changes
          if (event.type === 'input' || event.type === 'focusout') {
            // Clear first to force screen reader detection
            this.updatePointsValidationObject.errorMessageAnnouncement = "";
            // Re-assign after short delay to trigger screen reader re-announcement
            setTimeout(() => {
              this.updatePointsValidationObject.errorMessageAnnouncement = errorMessage;
            }, 150);
          }
        }
        this.updatePointsValidationObject.isDisableUpdatePoints = true;
      } else {
        // Only show error popup if not from updatePointsInput Flow
        const updatePointsInputElement = this.updatePointsInput?.getInputElement?.();
        if (!updatePointsInputElement || event.target !== updatePointsInputElement) {
          if (event.target && event.target.id) {
            const element = this.render.selectRootElement("#" + event.target.id);
            this.shareDataService.setLastFocusedEl(element);
            this.shareDataService.sendMessageData(message);
          }
        }
      }
    }
  }
  public sortedQuestionsList() {
    if (this.selectedQuestionsList.length > 0) {
      this.selectedQuestionsList.sort(function (question1, question2) {
        return question1.index - question2.index;
      });
      return this.selectedQuestionsList;
    }
  }

  public setArrayIndex(arrayIndex: number) {
    this.arrayIndex = arrayIndex;
  }

  public hideAddQuestion(event) {
    if (event) {
      this.hideHeader = true;
    }
    this.shouldAutoFocusSourcePicker = false;
  }

  public hideLeftPanel(event) {
    if (event) {
      this.panelClosed = true;
    }
    this.shouldAutoFocusSourcePicker = false;
  }
  public filterEvent(event) {
    if (event) {
      this.showSettings = true;
      this.tabIndex = 1;
      this.showCreateButton = false;
      this.cdr.detectChanges();
      this.tabsComponent?.focusTabByIndex(1);
    } else {
      this.showSettings = false;
    }
  }

  public tabClick(event) {
    this.tabIndex = event;
    if (this.tabIndex == 0) {
      this.router.navigate(["/editAssessment", "edit"]);
      // In SPAs, screen readers don't auto-detect title changes. LiveAnnouncer explicitly announces the page title for accessibility.
      this.queueLiveAnnouncement(this.pageTitle, 'assertive');
    } else {
      this.step = "step2";
    }
  }

  public setCurrentFocusElement(event) {
    this.currentFocusedElement = event;
  }

  getItemData(val) {
    val = val.itemInfo.questions[0];
    let randomNumber = Math.random().toString().substring(2);
    val.uniqueId = val.qid + "-" + randomNumber;
    this.selectedQuestionsListObj.unshift(val);

    this.questionIdArray = [];
    this.assignArrayIndex();
    this.arrayPinnedQuestions();
    this.assignSelectedQuestionArray();
    this.updateSelectAllCheckboxState();

    // Announce question creation success
    this.liveAnnouncer.announce(QUESTION_ADDED_SUCCESS_MESSAGE, 'polite');
  }
  sourceQuestionUpdate(val) {
    val = val.response.itemInfo.questions[0];
    let randomNumber = Math.random().toString().substring(2);
    val.uniqueId = val.qid + "-" + randomNumber;
    var getPos: number = -1;
    getPos = this.shareDataService.getEditedQuestionIndex();
    if (getPos > -1) {
      let questType = this.shareDataService.getEditedQuestionType();

      if (questType === "section-break") {
        // sction break new question add
        val.edited = 1;
        //this.selectedQuestionsListObj[getPos].parts.push(val);
        this.selectedQuestionsListObj[getPos].parts.splice(0, 0, val);
        this.assignArrayIndexSectionBreakQuestion(
          this.selectedQuestionsListObj
        );
        // Announce part question added
        this.liveAnnouncer.announce(QUESTION_ADDED_SUCCESS_MESSAGE, 'polite');
      } else if (questType === "section-break-part-question") {
        // section break part question edit or copyedit for my question
        let partInfo = this.shareDataService.getPartQuestionEditedInfo();
        if (
          partInfo.hasOwnProperty("multiPartId") &&
          partInfo.multiPartId != ""
        ) {
          this.selectedQuestionsListObj = this.selectedQuestionsListObj.map(
            (item) => {
              if (partInfo.multiPartId == item.multiPartId) {
                if (partInfo.copyy === true) {
                  val.edited = 1;
                  item.parts.unshift(val);
                } else {
                  var partQuesIndex = partInfo.index;
                  val.edited = 1;
                  item.parts[partQuesIndex] = val;
                }
              }
              return item;
            }
          );
          // Announce appropriate message based on operation type
          if (partInfo.copyy === true) {
            this.liveAnnouncer.announce(QUESTION_ADDED_SUCCESS_MESSAGE, 'polite');
          } else {
            this.liveAnnouncer.announce(QUESTION_EDITED_SUCCESS_MESSAGE, 'polite');
          }
        }

        this.shareDataService.setPartQuestionEditedInfo({});
      } else if (questType == "section-break-part-question-copy-edit") {
        // section break part question edit for library question
        let partInfo = this.shareDataService.getPartQuestionEditedInfo();
        if (
          partInfo.hasOwnProperty("multiPartId") &&
          partInfo.multiPartId != ""
        ) {
          // Removed the existing item

          for (var i = this.selectedQuestionsListObj.length; i--; ) {
            if (
              this.selectedQuestionsListObj[i].multiPartId ==
              partInfo.multiPartId
            ) {
              this.selectedQuestionsListObj.splice(i, 1);
            }
          }
        }

        for (let i = 0; i < val.parts.length; i++) {
          if (i == getPos) {
            val.parts[i].edited = 1;
          }
        }
        this.selectedQuestionsListObj.unshift(val);
        this.shareDataService.setPartQuestionEditedInfo({});
        // Announce section break question edited
        this.liveAnnouncer.announce(QUESTION_EDITED_SUCCESS_MESSAGE, 'polite');
      } else {
        //val.edited = 1;
        var newpartid = this.shareDataService.getNewPartQuestionId();
        if (typeof newpartid != "undefined" && newpartid != "-1") {
          if (val.hasOwnProperty("parts")) {
            for (let i = 0; i < val.parts.length; i++) {
              if (val.parts[i].qid == newpartid) {
                val.parts[i].edited = 1;
              }
            }
          }
          this.shareDataService.setNewPartQuestionId("-1");
          // Announce new part question added
          this.liveAnnouncer.announce(QUESTION_ADDED_SUCCESS_MESSAGE, 'polite');
        } else {
          val.edited = 1;
          // Announce question edited
          this.liveAnnouncer.announce(QUESTION_EDITED_SUCCESS_MESSAGE, 'polite');
        }

        // this.shareDataService.setEditedQuestionIndex(-1);
        //this.assignArrayIndexSectionBreakQuestion(this.selectedQuestionsListObj);
        if (questType == "section-break-lib-question-edit") {
          this.selectedQuestionsListObj.splice(getPos, 1);
          this.selectedQuestionsListObj.unshift(val);
        } else {
          this.selectedQuestionsListObj[getPos] = val;
        }
      }
      this.shareDataService.setEditedQuestionType("");
      this.shareDataService.setEditedQuestionIndex(-1);
    } else {
      val.edited = 1;
      this.selectedQuestionsListObj.unshift(val);
      // Announce question copied and added
      this.liveAnnouncer.announce(QUESTION_ADDED_SUCCESS_MESSAGE, 'polite');
    }

    this.questionIdArray = [];
    this.assignArrayIndex();
    this.assignArrayIndexSectionBreakQuestion(this.selectedQuestionsListObj);
    this.arrayPinnedQuestions();
    this.setKebabPreviewIndex();
    this.assignSelectedQuestionArray();
    this.updateSelectAllCheckboxState();
  }

  changeSourcePicker() {
    this.showBank = true;
    this.hideHeader = false;
    this.count = 0;
    this.isExpand = false;
    this.textExpand = "Expand All";
    this.child.clearSelection();
    this.shouldAutoFocusSourcePicker = true;
  }
  indexCal(i, j) {
    return i + "." + j;
  }
  assignArrayIndexSectionBreakQuestion(data) {
    this.selectedQuestionsListObj = data.map((question, index) => {
      if (question.hasOwnProperty("parts")) {
        if (!question.hasOwnProperty("uniqueId")) {
          let randomNumber = Math.random().toString().substring(2);
          question.uniqueId = question.qid + "-" + randomNumber;
        }
        let ind = 0;
        question.parts.map((partQuestion) => {
          partQuestion.index = ind++;
          partQuestion.previewIndex = index + ind;
          partQuestion.uniqueId = partQuestion.qid + "-" + index;
          partQuestion.parentUniqueId = question.uniqueId;
          return partQuestion;
        });
        this.computeSectionBreakAriaChecked(question);
      }
      return question;
    });
  }
  confirmSectionBreakRemove() {
    this.executeSoftSourceDelete(this.sectionBreakRemoveObj);
    this.toggleAddRemoveButtonPreviewModal(this.sectionBreakRemoveObj, true);
  }
  closeSectionBreakModal() {
    this.showSectionBreakQuestionDeleteModal = false;
    this.partQuestionRemove = false;
    this.secBreakRemove = false;

    if (this.lastTriggeringKebabButton) {
      const buttonToRefocus = this.lastTriggeringKebabButton;
      this.lastTriggeringKebabButton = null;
      // Use setTimeout to ensure that the focus happens after the modal has fully closed
      setTimeout(() => {
        buttonToRefocus.focus();
      }, 0);
    }
  }
  confirmPartQuestionRemove() {
    this.executePartQuestionRemove(this.sectionPartsRemoveObj);
    this.toggleAddRemoveButtonPreviewModal(this.sectionPartsRemoveObj, true);
  }
  decideBottomBorder(selectedQuestions, j) {
    return selectedQuestions.parts.length - 1 == j ? "bottom-border" : "";
  }
  decideTopBorder(selectedQuestions, j) {
    return 0 == j ? "top-border" : "";
  }
  decideTopLeftCorner(j) {
    return 0 == j ? "border-top-left-radius" : "";
  }
  decideTopRightCorner(j) {
    return 0 == j ? "border-top-right-radius" : "";
  }
  decideBottomRightCorner(selectedQuestions, j) {
    return selectedQuestions.parts.length - 1 == j
      ? "border-bottom-right-radius"
      : "";
  }
  decideBottomLeftCorner(selectedQuestions, j) {
    return selectedQuestions.parts.length - 1 == j
      ? "border-bottom-left-radius"
      : "";
  }
  setBackground() {
    return "part-background";
  }
  borderLeft() {
    return "part-border-left";
  }
  borderRight() {
    return "part-border-right";
  }
  isSectionBreak(refType) {
    return refType == "multipart" ? true : false;
  }

  selectAllPartQues(selectedQuestions, event) {
    var that = this;
    this.selectedQuestionsListObj.forEach((item) => {
      item.selected = event;
      if (item.selected && this.selectedQuestionsList.indexOf(item) === -1) {
        this.selectedQuestionsList.push(item);
      } else if (!item.selected) {
        const index = this.selectedQuestionsList.indexOf(item);
        this.selectedQuestionsList.splice(index, 1);
      }
    });
    that.renameActivated = this.selectedQuestionsList.length > 0 ? false : true;
  }

  noRightScalar(val) {
    return val ? "sb-kebab-cont" : "scalar-kebab-cont";
  }

  previewTestQuestions() {
    this.isPreviewTestQuestions = true;
    this.previewQuestionsList = [];
    this.pushPartQuestionPreviewQuestionsList();
    var userSelectedOptions = false;
    var tempPreviewList = [];
    if (this.selectedQuestionsListObj?.length > 0) {
      this.selectedQuestionsListObj.forEach((itm, index) => {
        let ind = this.previewQuestionsList.find(
          (x) => x.uniqueId == itm.uniqueId
        ).previewIndex;
        let tempOb = Object.assign({}, itm);
        tempOb.index = ind + 1;
        tempOb.dropped = true;
        if (tempOb.selected === true) {
          if (ind > -1) {
            userSelectedOptions = true;
            tempPreviewList.push(tempOb);
            if (itm.hasOwnProperty("parts")) {
              tempOb.parts.forEach((item, indx) => {
                if (item.selected == true) {
                  let tempPartObj = Object.assign({}, item);
                  tempPartObj.dropped = true;
                  let pind = this.previewQuestionsList.find(
                    (x) => x.qid == item.qid
                  ).previewIndex;
                  //tempPartObj.index = tempOb.index+1+indx+1;
                  tempPartObj.index = pind + 1;
                  tempPreviewList.push(tempPartObj);
                }
              });
            }
          }
        } else if (tempOb.selected === false) {
          if (tempOb.hasOwnProperty("parts")) {
            tempOb.parts.forEach((item) => {
              if (item.selected == true) {
                userSelectedOptions = true;
                let tempPartObj = Object.assign({}, item);
                tempPartObj.dropped = true;
                let pind = this.previewQuestionsList.find(
                  (x) => x.qid == item.qid
                ).previewIndex;
                tempPartObj.index = pind + 1;
                tempPreviewList.push(tempPartObj);
              }
            });
          }
        }
      });
    }

    if (userSelectedOptions === false) {
      this.pushPartQuestionPreviewQuestionsList();
      this.setPreviewQuestionIndex();
    } else {
      this.previewQuestionsList = tempPreviewList;
    }
    // this.previewQuestionsList.map(item => {
    //   item.index = item.originalIndex;
    // })

    this.qIndex = 0;
  }

  resetSelectedQuestionsListObjIndex() {
    this.selectedQuestionsListObj.forEach((itm, index) => {
      itm.index = index;
      itm.selected = false;
      if (itm.hasOwnProperty("parts")) {
        itm.parts.forEach((item, pIndex) => {
          //itm.parts[pIndex].index = itm.index + pIndex + 1;
          itm.parts[pIndex].index = pIndex;
          itm.parts[pIndex].selected = false;
        });
      }
    });
    this.selectedTitle = { selected: false };
  }
  setPreviewQuestionIndex() {
    this.previewQuestionsList.forEach((itm, ind) => {
      this.previewQuestionsList[ind].index = ind + 1;
    });
  }

  receiveDataPreviewClicked(event) {
    this.previewSourceQuestions(event);
  }

  previewSourceQuestions(dataObj) {
    this.previewHeaderText = "Previewing all questions";
    let indexParts = 0;
    this.isPreviewSourceQuestions = true;
    let addQuestionsList: any = [];
    let listOfSelectedQuestion: any = [];
    addQuestionsList = this.bankObj.questions.itemInfo.questions;
    var userChecked = false;
    this.previewSourceQuestionsList = [];
    if (this.bankObj?.bank?.title == "My Questions") {
      this.previewHeaderText = "Previewing my questions";
    }

    addQuestionsList = this.questionListPipe.transform(
      addQuestionsList,
      this.filterJsonObject,
      true
    );
    addQuestionsList.forEach((item, index) => {
      let isDropped = this.selectedQuestionsListObj.find(
        (o) => o.qid === item.qid
      );
      item.dropped = isDropped ? true : false;
      indexParts = indexParts + 1;
      item["index"] = indexParts;
      this.previewSourceQuestionsList.push(item);
      if (item.selected) {
        userChecked = true;
        listOfSelectedQuestion.push(item);
      }
      if (item.hasOwnProperty("parts")) {
        let isDropped;
        item.parts = item.parts.map((partQuestion, ind) => {
          this.selectedQuestionsListObj.map((item) => {
            if (item.parts) {
              isDropped = item.parts.find((o) => o.qid === partQuestion.qid);
            }
          });

          // = this.selectedQuestionsListObj.find(o => o.qid === partQuestion.qid);
          partQuestion.dropped = isDropped ? true : false;
          indexParts = indexParts + 1;
          partQuestion["index"] = indexParts;
          this.previewSourceQuestionsList.push(partQuestion);
          if (item.selected) {
            listOfSelectedQuestion.push(partQuestion);
            userChecked = true;
          }
          return partQuestion;
        });
      }
    });

    this.questionIndex = 0;

    if (
      listOfSelectedQuestion &&
      listOfSelectedQuestion?.length > 0 &&
      !dataObj
    ) {
      this.previewHeaderText = "Previewing all selected questions";
      // this.previewSourceQuestionsList.forEach((item,index) => {
      //       if(item.qid === listOfSelectedQuestion[0].qid) this.questionIndex = index;
      //   });
      this.previewSourceQuestionsList = listOfSelectedQuestion;
    } else if (dataObj) {
      this.previewSourceQuestionsList.forEach((item, index) => {
        if (item.qid === dataObj.qid) this.questionIndex = index;
      });
    }
    if (listOfSelectedQuestion && listOfSelectedQuestion?.length > 0) {
      listOfSelectedQuestion.map((item, index) => {
        if (dataObj) {
          if (item.qid === dataObj.qid) {
            this.questionIndex = index;
            this.previewSourceQuestionsList = listOfSelectedQuestion;
          }
        }
      });
    }
  }

  isPreviewDisable() {
    let filteredData = this.questionListPipe.transform(
      this.bankObj.questions.itemInfo.questions,
      this.filterJsonObject,
      true
    );
    return filteredData.length == 0;
  }

  pushPartQuestionPreviewQuestionsList() {
    var tempPreviewQuestionsList = [];
    this.selectedQuestionsListObjStore = JSON.parse(
      JSON.stringify(this.selectedQuestionsListObj)
    );
    this.selectedQuestionsListObj.forEach((element, index) => {
      let tempOb = Object.assign({}, element);
      tempOb.originalIndex = index + 1;
      tempPreviewQuestionsList.push(tempOb);
      if (element.hasOwnProperty("parts")) {
        element.parts.forEach((item, pIndex) => {
          let tempPartOb = Object.assign({}, item);
          tempPartOb.originalIndex = tempOb.originalIndex + pIndex + 1;
          tempPreviewQuestionsList.push(tempPartOb);
        });

        //tempPreviewQuestionsList.push(...elepushPartQuestionPreviewQuestionsListment.parts);
      }
    });
    var pIndex = 0;
    tempPreviewQuestionsList = tempPreviewQuestionsList.map((elm) => {
      elm.dropped = true;
      elm.index = pIndex++;
      elm.previewIndex = elm.index;
      elm.isRemoved = false;
      return elm;
    });
    this.previewQuestionsList = tempPreviewQuestionsList;
  }

  kebabPreview(selectedQuestionsListObj) {
    this.getOnlinePreviewUrl(selectedQuestionsListObj);
  }

  setKebabPreviewIndex() {
    var mindex = 0;
    this.selectedQuestionsListObj.forEach((itm, index) => {
      itm.index = index;
      itm.previewIndex = mindex;
      itm.originalIndex = index + 1;
      if (itm.hasOwnProperty("parts")) {
        itm.parts.forEach((item, pIndex) => {
          itm.parts[pIndex].index = pIndex;
          itm.parts[pIndex].previewIndex = mindex + pIndex + 1;
          itm.parts[pIndex].originalIndex = itm.originalIndex + 1 + pIndex;
        });
        let partLength = itm.parts.length - 1;
        mindex = itm.parts[partLength].previewIndex;
      }
      mindex++;
    });
  }

  addQuestionClicked(event) {
    let selectedData = event.data;
    if (event.source == "SourcePanel") {
      this.previewQuestionsList.map((obj) => {
        if (obj.qid == event.data[0].qid) {
          obj.dropped = event.data[0].dropped;
        }
      });

      if (!selectedData[0].parts && selectedData[0]?.multiPartId) {
        if (event.data[0].dropped) {
          selectedData = this.getSectionBreakWrapper(event);
          this.previewSourceQuestionsList.map((obj) => {
            if (obj.qid == selectedData[0].qid) {
              obj.dropped = true;
              if (obj.parts) {
                obj.parts.map((item) => {
                  if (item.qid == event.data[0].qid) item.dropped = true;
                  return item;
                });
              }
            }
          });

          if (this.selectedQuestionsListObj.length > 0) {
            this.selectedQuestionsListObj.forEach((item) => {
              if (item.qid == selectedData[0].qid) {
                if (item.parts) {
                  item.parts.push(selectedData[0].parts[0]);
                }
              }
            });
            let isObjectExist = this.selectedQuestionsListObj.filter((item) => {
              return item.qid == selectedData[0].qid;
            });
            if (isObjectExist.length == 0)
              this.selectedQuestionsListObj.push(selectedData[0]);
          } else {
            this.selectedQuestionsListObj.push(selectedData[0]);
          }
        } else {
          selectedData = this.getSectionBreakWrapper(event);

          if (this.selectedQuestionsListObj.length > 0) {
            this.selectedQuestionsListObj.forEach((item) => {
              if (item.qid == selectedData[0].qid) {
                if (item.parts) {
                  item.parts = item.parts.filter((item) => {
                    return item.qid != event.data[0].qid;
                  });
                }
                if (item.parts.length == 0) {
                  this.selectedQuestionsListObj =
                    this.selectedQuestionsListObj.filter((item) => {
                      return item.qid != selectedData[0].qid;
                    });
                  let objIndex = this.previewSourceQuestionsList.findIndex(
                    (obj) => obj.qid == selectedData[0].qid
                  );

                  this.previewSourceQuestionsList[objIndex]["dropped"] = false;
                }
              }
            });
          }
        }
      } else {
        event.data[0].dropped
          ? this.addToRight(null, selectedData)
          : this.modalOkJob(event.data);
      }
    } else {
      this.addRemoveOperation(event);
    }

    this.createCollectionObject();
  }

  addRemoveOperation(data) {
    data.data = data.data[0];
    if (data.mode == "remove") {
      let sectionBreakId;
      if (
        data.data.refType == "scalar" &&
        data.data.hasOwnProperty("multiPartId") &&
        data.data.multiPartId != ""
      ) {
        sectionBreakId = data.data.parentUniqueId;
        let findSBQuestions = this.selectedQuestionsListObj.find(
          (itm) => itm.uniqueId == data.data.parentUniqueId
        );
        this.sectionBreakQuestionStore[sectionBreakId] = JSON.parse(
          JSON.stringify(findSBQuestions)
        );
      } else if (
        data.data.refType == "multipart" &&
        data.data.multiPartId != ""
      ) {
        sectionBreakId = data.data.uniqueId;
        this.sectionBreakQuestionStore[sectionBreakId] = data.data;
      }

      this.softSourceDelete(data.data);
    } else if (data.mode == "add") {
      let newItem = data.data;
      if (newItem.refType == "multipart") {
        let item;
        if (this.sectionBreakRemoveObj) {
          item = this.sectionBreakRemoveObj;
          const index = this.selectedQuestionsListObjStore.find(
            (itm) => itm.uniqueId == item.uniqueId
          ).index;
          let tempObjQuestions = JSON.parse(
            JSON.stringify(this.selectedQuestionsListObj)
          );
          tempObjQuestions.splice(index, 0, item);
          this.selectedQuestionsListObj = tempObjQuestions;
          this.toggleAddRemoveButtonPreviewModal(item, false);
        } else if (this.sectionPartsRemoveObj) {
          item = this.sectionPartsRemoveObj;
          let findParentQuestions =
            this.sectionBreakQuestionStore[newItem.uniqueId];
          if (findParentQuestions) {
            let tempObj = JSON.parse(
              JSON.stringify(this.selectedQuestionsListObj)
            );
            tempObj.splice(findParentQuestions.index, 0, newItem);
            this.selectedQuestionsListObj = tempObj;

            let addPartQuestion =
              this.selectedQuestionsListObj[findParentQuestions.index];
            addPartQuestion.parts.splice(0, 0, item);
            this.previewQuestionsList.find((itm) => {
              if (itm.uniqueId == item.uniqueId) {
                itm.isRemoved = false;
                itm.dropped = true;
              }
              if (itm.uniqueId == newItem.uniqueId) {
                itm.isRemoved = false;
                itm.dropped = true;
              }
            });
          } else {
            let tempObjQuestions = JSON.parse(
              JSON.stringify(this.selectedQuestionsListObj)
            );
            tempObjQuestions.splice(data.index, 0, item);
            this.selectedQuestionsListObj = tempObjQuestions;
          }
        } else {
          item = newItem;
          const index = this.selectedQuestionsListObjStore.find(
            (itm) => itm.uniqueId == item.uniqueId
          ).index;
          let tempObjQuestions = JSON.parse(
            JSON.stringify(this.selectedQuestionsListObj)
          );
          tempObjQuestions.splice(index, 0, item);
          this.selectedQuestionsListObj = tempObjQuestions;
        }
      } else if (
        newItem.refType == "scalar" &&
        newItem.hasOwnProperty("multiPartId") &&
        newItem.multiPartId != ""
      ) {
        let findParentQuestion = this.selectedQuestionsListObj.find(
          (itm) => itm.uniqueId == newItem.parentUniqueId
        );

        if (typeof findParentQuestion == "undefined") {
          let mulitpartid = newItem.parentUniqueId;
          findParentQuestion = this.sectionBreakQuestionStore[mulitpartid];
          let tempObjQuestions = JSON.parse(
            JSON.stringify(this.selectedQuestionsListObj)
          );
          tempObjQuestions.splice(
            findParentQuestion.index,
            0,
            findParentQuestion
          );
          this.selectedQuestionsListObj = tempObjQuestions;

          this.previewQuestionsList.find((itm) => {
            if (itm.uniqueId == findParentQuestion.uniqueId) {
              itm.isRemoved = false;
              itm.dropped = true;
            }
          });
          if (findParentQuestion.parts.length > 0) {
            findParentQuestion.parts = [];
          }
        }

        if (findParentQuestion?.hasOwnProperty("parts")) {
          let partQIndex;

          if (findParentQuestion.parts.length == 0) {
            partQIndex = 0;
          } else {
            this.sectionBreakQuestionStore[
              newItem.parentUniqueId
            ].parts.forEach((element, index) => {
              if (element.qid == newItem.qid) {
                partQIndex = index;
              }
            });
          }

          findParentQuestion.parts.splice(partQIndex, 0, newItem);
          this.setKebabPreviewIndex();
        }
      } else {
        const index = this.selectedQuestionsListObjStore.find(
          (itm) => itm.uniqueId == data.data.uniqueId
        ).index;
        let tempObj = JSON.parse(JSON.stringify(this.selectedQuestionsListObj));
        tempObj.splice(index, 0, data.data);
        this.selectedQuestionsListObj = tempObj;
        this.bankObj.questions.itemInfo.questions.filter((item) => {
          if (item.uniqueId == data.data.uniqueId) {
            item.dropped = true;
          }
        });
      }
      this.setCollectionInfoInHeader();
    }
    setTimeout(() => {
      this.pointsAlignment();
    }, 100);
  }

  getSectionBreakWrapper(event) {
    let selectedData;
    this.bankObj.questions.itemInfo.questions.map((item) => {
      if (item?.parts && event?.data[0]?.multiPartId == item?.multiPartId) {
        let tempData = [];
        let x = JSON.parse(JSON.stringify(item));
        tempData.push(x);
        tempData[0].parts = [];
        tempData[0].parts.push(event.data[0]);
        selectedData = JSON.parse(JSON.stringify(tempData));
      }
    });
    return selectedData;
  }

  toggleAddRemoveButtonPreviewModal(obj, value) {
    if (this.previewQuestionsList?.length > 0) {
      let partIdStore = [];
      if (obj.parts?.length > 0) {
        obj.parts.find((itm) => {
          partIdStore.push(itm.uniqueId);
        });
      }

      this.previewQuestionsList.find((element) => {
        if (element.uniqueId == obj.uniqueId) {
          // Selected Question
          element.isRemoved = value;
          element.dropped = !value;
        }

        if (partIdStore.indexOf(element.uniqueId) > -1) {
          // Part Question
          element.isRemoved = value;
          element.dropped = !value;
        }

        if (partIdStore.length == 0) {
          // Parent Question
          if (element.uniqueId == obj.parentUniqueId) {
            element.isRemoved = value;
            element.dropped = !value;
          }
        }
      });
    }
  }

  pointsAlignment() {
    let scrollHeight = document.getElementById("test-panel").scrollHeight;
    let clientHeight = document.getElementById("test-panel").clientHeight;

    this.pointAlignment = "point-alignment";
    this.typeAlignment = "type-alignment";

    if (scrollHeight > clientHeight) {
      this.pointAlignment = "point-alignment-resize";
      this.typeAlignment = "type-alignment-resize";
    }
  }

  public clearSearch() {
    this.textSearchLeft = "";
    this.clearSearchInputLeft?.focus();
  }
  public clearSearchRight() {
    this.searchedTextRight = "";
    this.dataChanged(true);
    this.clearSearchInputRight?.focus();
  }
  dataChanged(announceSearchResultRight: boolean = false) {
    let filteredArray = [];
    if (this.searchedTextRight.trim() != "") {
      filteredArray = this.filterSearchedItem(this.selectedQuestionsListObj);
    } else {
      filteredArray = this.selectedQuestionsListObj;
    }
    this.currentPage(filteredArray);
    
    // Validate pagination state after data changes
    this.validatePaginationState();
    
    if (announceSearchResultRight) {
      this.updateResultsAnnouncement();
    }
  }
  filterSearchedItem(totalQuestionAR) {
    const questionArray = [];
    totalQuestionAR.map((findData) => {
      let dataFound =
        findData.preview
          .toLowerCase()
          .search(this.searchedTextRight.toLowerCase().trim()) !== -1;
      if (findData.hasOwnProperty("parts") && !dataFound) {
        for (let i = 0; i < findData.parts.length; i++) {
          if (
            findData.parts[i].preview
              .toLowerCase()
              .search(this.searchedTextRight.toLowerCase().trim()) !== -1
          ) {
            dataFound = true;
            break;
          }
        }
      }
      if (dataFound) {
        questionArray.push(findData);
      }
    });
    this.totalSearchCountRight = questionArray.length;
    return questionArray;
  }

  /**
   * Validates and adjusts pagination state to ensure currentPageIndex is within valid bounds
   */
  validatePaginationState() {
    if (!this.questionCollection || Object.keys(this.questionCollection).length === 0) {
      this.currentPageIndex = 0;
      return;
    }
    
    const maxPageIndex = Object.keys(this.questionCollection).length - 1;
    
    // If current page index exceeds available pages, adjust to last valid page
    if (this.currentPageIndex > maxPageIndex) {
      this.currentPageIndex = Math.max(0, maxPageIndex);
    }
    
    // If current page is empty but questions exist, find first non-empty page
    if (this.questionCollection[this.currentPageIndex]?.length === 0 && this.selectedQuestionsListObj.length > 0) {
      for (let i = 0; i <= maxPageIndex; i++) {
        if (this.questionCollection[i]?.length > 0) {
          this.currentPageIndex = i;
          break;
        }
      }
    }
  }

  assignSelectedQuestionArray() {
    let arrayIndex = 0;
    if (this.selectedQuestionsListObj) {
      this.selectedQuestionsListObj.forEach((item) => {
        item["index"] = arrayIndex++;
        this.selectedQuestionArray.set(item.qid + "-main", item.hasOwnProperty("parts"));
        if (item.hasOwnProperty("parts")) {
          item["parts"].map((val) => {
            this.selectedQuestionArray.set(val.qid + "-parts", false);
          });
        }
      });
      this.hasExpanded = false;
      this.expandToggleText = "Expand All";
    }
  }
  toggleQuestionHideArray(questionId: string) {
    const isExpand = this.selectedQuestionArray.get(questionId);
    this.selectedQuestionArray.set(questionId, !isExpand);
    this.updateExpandToggleButtonState();
  }

  updateExpandToggleButtonState() {
    const allExpanded = [...this.selectedQuestionArray.values()].every(
      isExpanded => isExpanded
    );
    this.hasExpanded = allExpanded;
    this.expandToggleText = allExpanded ? "Collapse All" : "Expand All";
  }

  expandAllToggle() {
    this.hasExpanded = !this.hasExpanded;
    this.selectedQuestionArray.forEach((values, keys) => {
      this.selectedQuestionArray.set(keys, this.hasExpanded);
    });
    this.cdr.detectChanges();
    this.expandAllSubject.next();
    if (this.hasExpanded) {
      this.expandToggleText = "Collapse All";
    } else {
      this.expandToggleText = "Expand All";
    }
    this.liveAnnouncer.announce(`${this.expandToggleText} for Your Test`, "polite");
  }

  closeUpdateBulkPointsModal() {
    // Clear box shadow on the input to prevent previous styles from carrying over when the modal reopens
    const inputElement = this.updatePointsInput.getInputElement();
    if (inputElement) {
      this.render.removeClass(inputElement, this.updatePointsValidInputClass);
      this.render.removeClass(inputElement, this.updatePointsInvalidInputClass);
      this.render.removeAttribute(inputElement, "aria-invalid");
    }
    this.updatePointsValidationObject.callFromUpdatePoints = false;
    this.updatePointsValidationObject.isDisableUpdatePoints = true;
    this.modalIsVisible = false;
    this.bulkUpdatePointsSelectedQuestionCount = 0;
    this.updatePointsValidationObject.showInvalidMessage = "";
  }
  showUpdatePointsAlrtModal() {
    this.modalIsVisible = !this.modalIsVisible;
    // Reset input validation classes
    if (this.modalIsVisible) {
      this.updatePointsValidationObject.callFromUpdatePoints = false;
      this.updatePointsValidationObject.isDisableUpdatePoints = true;
      this.updatePointsValidationObject.showInvalidMessage = "";
      this.updatePointsValidationObject.errorMessageAnnouncement = "";
      if (this.updatePointsInput) {
        const inputElement = this.updatePointsInput.getInputElement();
        if (inputElement) {
          this.render.removeClass(inputElement, this.updatePointsValidInputClass);
          this.render.removeClass(inputElement, this.updatePointsInvalidInputClass);
          this.render.removeAttribute(inputElement, "aria-invalid");
        }
      }
    }
  }
  updatePoints() {
    this.selectedQuestionsListObj.map((value) => {
      if (value.selected && !value.hasOwnProperty("parts")) {
        this.bulkUpdatePointsSelectedQuestionCount++;
      }
      if (value?.parts && value?.parts.length > 0) {
        value?.parts.map((pitem) => {
          if (pitem.selected) {
            this.bulkUpdatePointsSelectedQuestionCount++;
          }
        });
      }
    });
    this.bulkUpdatePointInputValue = "0.00";
    this.showUpdatePointsAlrtModal();
  }
  public onChange(event) {
    this.bulkUpdatePointInputValue = event.value;
    this.updatePointsValidationObject.callFromUpdatePoints = true;
    this.updatePointsValidationObject.isDisableUpdatePoints = false;
    this.updatePointsValidationObject.showInvalidMessage = "";
    this.validatePoints(event.event);
  }
  ngOnChanges(event) {
    this.cdr.detectChanges();
  }
  ngOnDestroy() {
    if (this.closeTimer) {
      clearTimeout(this.closeTimer);
      this.closeTimer = null;
    }
  }
  updateBulkPoints() {
    this.updatePointsValidationObject.isDisableUpdatePoints = true;

    this.modalIsVisible = false;
    this.selectedQuestionsListObj.map((value, index) => {
      if (value.selected) {
        this.selectedQuestionsListObj[index].points =
          this.bulkUpdatePointInputValue;
      }
      if (value?.parts && value?.parts.length > 0) {
        value?.parts.map((pitem, pindex) => {
          if (pitem.selected) {
            value.parts[pindex].points = this.bulkUpdatePointInputValue;
          }
        });
      }
    });
    // Update UI and announce success once after all updates complete
    // Pass true to skip default announcement since we'll make a combined announcement
    this.pointsChanged(null, true);
    this.showSuccessMessage = true;
    this.suppressAnnouncement = true;
    this.showSuccessAlert(UPDATE_POINTS_SUCCESS_MSG);
    
    // Combine points update success message with total points for a single announcement
    const totalPoints = this.headerData.getTotalPoints();
    const combinedAnnouncement = `${UPDATE_POINTS_SUCCESS_MSG}. Total points ${totalPoints}`;
    this.queueLiveAnnouncement(combinedAnnouncement, 'polite', this.successAlertDuration, this.removalAnnouncementDelay);
  }
  showSuccessAlert(message: string) {
    // Clear any existing close timer
    if (this.closeTimer) {
      clearTimeout(this.closeTimer);
      this.closeTimer = null;
    }
    this.showSuccessMessage = false;
    this.cdr.detectChanges();
    this.alertSuccessMessage = message;
    this.showSuccessMessage = true;
    this.closeUpdateBulkPointsModal();
    this.closeTimer = setTimeout(() => {
      this.showSuccessMessage = false;
      this.suppressAnnouncement = false;
      this.cdr.detectChanges();
    }, this.successAlertDuration);
  }
  closeAlert() {
    if (this.closeTimer) {
      clearTimeout(this.closeTimer);
      this.closeTimer = null;
    }
    this.showSuccessMessage = false;
    this.suppressAnnouncement = false;
  }
  updateChangeValueOfDropdown(value) {
    this.showQuestion = value;
  }
  changeshowQuestion() {
    this.showQuestion = !this.showQuestion;
  }
  setParts(partData, title) {
    for (let i = 0; i < partData.length; i++) {
      partData[i].bankName = title;
    }
    return partData;
  }

  previeExamStatistics() {
    const sourceInfoDataList = this.shareDataService.getSourceInfoDataList();
    this.collection.references.map((val: References, index) => {
      let remTid = val.getTid();
      sourceInfoDataList.banks.map((data: BankModel) => {
        if (remTid === data.ezid) {
          this.collection.references[index].setBankName(data.title);
          this.collection.references[index].setIsbn(sourceInfoDataList.isbn);
          remTid = "";
          const parts = this.collection.references[index].getParts();
          if (parts !== undefined) {
            this.collection.references[index].setParts(
              this.setParts(parts, data.title)
            );
          }
        }
      });
      if (
        sourceInfoDataList.hasOwnProperty("myquestions") &&
        val.getTid() === sourceInfoDataList.myquestions.ezid
      ) {
        this.collection.references[index].setBankName(
          sourceInfoDataList.myquestions.title
        );
        this.collection.references[index].setIsbn(null);
        const parts = this.collection.references[index].getParts();
        if (parts !== undefined) {
          this.collection.references[index].setParts(
            this.setParts(parts, sourceInfoDataList.myquestions.title)
          );
        }
      } else if (remTid != "") {
        this.collection.references[index].setBankName("myquestions");
        this.collection.references[index].setIsbn(null);
        const parts = this.collection.references[index].getParts();
        if (parts !== undefined) {
          this.collection.references[index].setParts(
            this.setParts(parts, "myquestions")
          );
        }
      }
    });
    let payloadRefrences: any = [];
    this.collection.references.forEach((x: any) => {
      let params: any = {
        ezid: x.tid,
        qid: x.qid,
        bankName: x.bankName,
        parts: [],
      };
      if (x.parts && x.parts.length > 0) {
        x.parts.forEach((y: any) => {
          params.parts.push({
            ezid: y.tid,
            qid: y.qid,
            bankName: y.bankName,
          });
        });
      }
      if (params.parts.length == 0) {
        delete params.parts;
      }
      payloadRefrences.push(params);
    });
    let modifiedPayloadRefrences = { references: payloadRefrences };
    this.sourceBankQuestion
      .getExamStatistics(modifiedPayloadRefrences)
      .subscribe(
        (response: any) => {
          for (let res in response) {
            this.examStatsticsList[res] = response[res];
          }
          this.showExamStatisticsAlrtModal();
        },
        (error) => {
          this.error = error;
        }
      );
  }
  examStatisticsConfirm() {
    this.examStatisticsModalIsVisible = false;
  }
  showExamStatisticsAlrtModal() {
    this.examStatisticsModalIsVisible = !this.examStatisticsModalIsVisible;
  }
  closeExamStatistics() {
    this.examStatisticsModalIsVisible = false;
  }
  sourceSelectSortPredicate = (index: number, drag: CdkDrag, drop: CdkDropList) => {
    // If item is being dragged from leftList to rightList, only allow drop at the end
    if (drag.dropContainer.id === 'leftList' && drop.id === 'test-panel') {
      return index >= drop.data.length;
    }

    // Allow normal sorting within the same container
    return true;
  };

  isEditedQuestion(selectedQuestions: SelectSourceQuestion): boolean {
    return (
      (!this.isSectionBreak(selectedQuestions.refType) && selectedQuestions.userEdited) ||
      (this.isSectionBreak(selectedQuestions.refType) && selectedQuestions.edited === 1)
    );
  };
  focusCreateQuestion(): void {
    this.createQuestionDropdown?.focusDropdown();
  }
  handleCountChange(count: number) {
    this.finalFilterCount = count;
  }
  private updateResultsAnnouncement() {
    const resultCount = this.totalSearchCountRight;
    const resultLabel = `${resultCount} search result${resultCount !== 1 ? 's' : ''}`;
    if (this.searchedTextRight.trim().length >= 1) {
      this.searchResultsAnnouncement = `${resultLabel} found for '${this.searchedTextRight.trim()}'`;
    } else {
      this.searchResultsAnnouncement = resultLabel;
    }
  }

   /**
   * Handles the mouse down event on the page.
   * If a question is currently grabbed, resets the drag and drop keyboard interaction
   * This ensures that switching from keyboard to mouse interaction
   * properly resets any relevant state.
   */
  @HostListener('document:mousedown', ['$event'])
  public onMouseDown() {
    if (this.grabbedQuestion) {
      // Reset keyboard interaction when switched to mouse interaction
      this.handleQuestionReset(this.grabbedIndex);
    }
  }

  /**
   * Handles the drag event of question from left panel.
   * When dragging starts, triggers the `dragStarted` method and adds a background highlight.
   * When dragging ends, removes the background highlight.
   *
   * @param dragStarted - Indicates whether the drag operation has started (`true`) or ended (`false`).
   */
  sourceDrag(dragStarted: boolean) {
    if (dragStarted) {
      this.dragStarted();
      this.showDropHint = true;
    } else {
      this.removeDropZoneHighlight();
      this.showDropHint = false;
    }
  }

  /**
   * Handles the logic when a drag operation starts.
   * - Updates the icon color in the drag preview element.
   * - Highlights the drop zone
   */
  dragStarted() {
    const dragPreviewElem = document.getElementsByClassName('cdk-drag-preview');
    if (dragPreviewElem?.length > 0) {
      const preview = dragPreviewElem[0] as HTMLElement;
      const movingTileIcons = preview.querySelectorAll('.dpg-icon-movingtile');
      movingTileIcons.forEach((icon: Element) => {
        icon.classList.remove('dpg-icon-movingtile');
        icon.classList.add('dpg-icon-movingtile-white');
      });
    }
    if (this.selectedQuestionsListObj?.length === 0) {
      this.dropZoneNoQuestion.nativeElement.classList.add('drop-zone-highlight');
    } else {
      this.dropZoneWithQuestion.nativeElement.classList.add('drop-zone-highlight');
    }
  }

  /**
   * Moves a question up or down within the selected questions list, handling both keyboard and kebab menu actions.
   * Updates the internal state to reflect the reordering, triggers change detection, and sets appropriate messages and focus.
   * @param isMoveUp - If `true`, moves the question up; if `false`, moves it down.
   * @param questionIndex - The index of the question on the current page to move.
   * @param kebabAction - Optional. If `true`, indicates the action was triggered via the kebab menu; defaults to `false`.
   */
  public moveQuestionUpDown(isMoveUp: boolean, questionIndex: number, kebabAction: boolean = false) {
    if (!this.isReordered && !kebabAction) {
      this.isReordered = true;
      this.reorderedQuestionIndex = questionIndex;
    }
    const currentQuestionIndex = this.currentPageIndex * this.pageSize + questionIndex;
    if (isMoveUp) {
      [this.selectedQuestionsListObj[currentQuestionIndex - 1], this.selectedQuestionsListObj[currentQuestionIndex]] = [this.selectedQuestionsListObj[currentQuestionIndex], this.selectedQuestionsListObj[currentQuestionIndex - 1]];
    } else {
      [this.selectedQuestionsListObj[currentQuestionIndex], this.selectedQuestionsListObj[currentQuestionIndex + 1]] = [this.selectedQuestionsListObj[currentQuestionIndex + 1], this.selectedQuestionsListObj[currentQuestionIndex]];
    }
    this.reorderList();
    this.cdr.detectChanges();
    const nextElementIndex = questionIndex + (isMoveUp ? -1 : 1);
    const nextElementAbsoluteIndex = (this.currentPageIndex * this.pageSize) + nextElementIndex;
    const movedElement = this.selectedQuestionsListObj[nextElementAbsoluteIndex];
    if (kebabAction) {
      this.setKebabIndex(-1);
      if (isMoveUp) {
        const newElem = this.questionKebabs.find(el => el.element.nativeElement.id === ('questionKebab' + nextElementIndex));
        newElem?.injector.get(KebabComponent).focusOnButton();
        newElem?.element.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
      this.reorderMessage = `Question ${movedElement?.title} moved to position ${nextElementAbsoluteIndex + 1} of ${this.selectedQuestionsListObj.length}.`;
      this.deselectedIndex = null;
    } else {
      this.setFocusAndScroll(nextElementIndex);
      this.setGrabbedQuestion(movedElement, nextElementIndex);
      this.reorderMessage = `Question ${movedElement?.title} moved to position ${nextElementAbsoluteIndex + 1} of ${this.selectedQuestionsListObj.length}. Press Enter/Space to confirm or Escape to cancel.`;
    }
  }

  /**
   * Handles the click event on a drag handle for a question in the source select component.
   * If a question is already grabbed, it resets the previously grabbed question.
   * Then, it sets the newly grabbed question and closes any open drag handle tooltips.
   * @param question - The question object associated with the clicked drag handle.
   * @param index - The index of the question in the list.
   */
  public dragHandleClicked(question: SelectSourceQuestion, index: number): void {
    if (this.grabbedQuestion) {
      this.resetGrabbedQuestion(this.grabbedIndex);
    }
    this.setGrabbedQuestion(question, index);
    closeOpenTooltips(this.dragHandleTooltips);
  }

  /**
   * Handles keyboard events for drag-and-drop interactions on questions in right panel.
   *
   * - Selects a question/Confirm reorder action when Enter or Space is pressed.
   * - Resets the question selection when Escape is pressed.
   * - Moves the grabbed question up or down in the list when Ctrl/Meta + ArrowUp/ArrowDown is pressed.
   *
   * @param event - The keyboard event triggered by user interaction.
   * @param question - The question object associated with the current selection.
   * @param index - The index of the current question in the list.
   * @param isLast - Indicates if the current question is the last in the list.
   */
  public dragHandlerKeydown(event: KeyboardEvent, question: SelectSourceQuestion, index: number, isLast: boolean) {
    if (this.grabbedQuestion || event.key === KeyAction.Space) {
      // if a question is already grabbed, prevent default to avoid default browser behavior of keys like tab, enter, etc.
      // If space is pressed, we want to avoid scrolling the page
      event.preventDefault();
    }
    if (event.key === KeyAction.Enter || event.key === KeyAction.Space) {
      this.handleQuestionSelection(question, index);
    }
    else if (event.key === KeyAction.Escape) {
      this.handleQuestionReset(index, true);
    }
    else if (this.grabbedQuestion && this.grabbedIndex > 0 &&
      (event.key === KeyAction.ArrowUp && (event.ctrlKey || event.metaKey))
    ) {
        this.moveQuestionUpDown(true, this.grabbedIndex);
      }
    else if (this.grabbedQuestion && !isLast &&
      (event.key === KeyAction.ArrowDown && (event.ctrlKey || event.metaKey))
    ) {
        this.moveQuestionUpDown(false, this.grabbedIndex);
    }
  }

  /**
   * Handles the selection of a question in the source select component.
   * If the questions have been reordered, confirms the new position of the grabbed question,
   * displays a reorder message for screen readers, and resets the reorder state and grabbed question.
   * Otherwise, sets the grabbed question and closes any open drag handle tooltips.
   * @param question - The question that was selected.
   * @param index - The index of the selected question.
   */
  private handleQuestionSelection(question: SelectSourceQuestion, index: number): void {
    if (this.isReordered) {
      this.reorderMessage = `Question ${this.grabbedQuestion?.title} position confirmed`;
      this.resetReorderState();
      this.resetGrabbedQuestion(index);
    }
    else {
      this.setGrabbedQuestion(question, index);
      closeOpenTooltips(this.dragHandleTooltips);
    }
  }

  /**
   * Sets focus and scrolls to the drag handle element when question is reordered.
   * Also closes any open tooltips associated with drag handles.
   */
  private setFocusAndScroll(newIndexToFocus: number) {
    const newElem = this.dragHandles.find(el => el.nativeElement.id === ('drag-handle-' + newIndexToFocus));
    newElem?.nativeElement.focus();
    newElem?.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    closeOpenTooltips(this.dragHandleTooltips);
  }

  /**
   * Resets question state after reorder or selection.
   * If reordered, moves question back to original position and resets state.
   * Otherwise, just resets grabbed question.
   */
  private handleQuestionReset(index: number, isKeyboardEvent: boolean = false): void {
    if (this.isReordered) {
      const oldIndex = this.reorderedQuestionIndex;
      // If a question is being reordered, reset the state
      const fromIndex = (this.currentPageIndex * this.pageSize) + this.grabbedIndex;
      const toIndex = (this.currentPageIndex * this.pageSize) + this.reorderedQuestionIndex;
      const [question] = this.selectedQuestionsListObj.splice(fromIndex, 1);
      this.selectedQuestionsListObj.splice(toIndex, 0, question);
      this.reorderList();
      this.reorderMessage = `Question ${question?.title} reset to original position.`;
      this.resetGrabbedQuestion(this.reorderedQuestionIndex);
      this.resetReorderState();
      if (isKeyboardEvent) {
        this.cdr.detectChanges();
        this.setFocusAndScroll(oldIndex);
      }
    } else {
      this.resetGrabbedQuestion(index);
    }
  }

  private resetReorderState() {
    this.isReordered = false;
    this.reorderedQuestionIndex = null;
  }

  private setGrabbedQuestion(question: SelectSourceQuestion, index: number) {
    this.grabbedQuestion = question;
    this.grabbedIndex = index;
    this.deselectedIndex = null;
  }

  private resetGrabbedQuestion(index: number | null) {
    this.grabbedQuestion = null;
    this.grabbedIndex = null;
    this.deselectedIndex = index;
  }
  /**
   * Triggered when one or more questions are removed.
   * Sets focus to the first available question checkbox,
   * or to the "Create Question" button if no checkboxes remain.
   */
  private focusCheckboxOrCreateQuestion (focusIndex?: number): void {
    this.cdr.detectChanges();
    const questionCheckboxToFocus = focusIndex !== undefined ? this.questionCheckboxes.get(focusIndex % this.pageSize) : this.questionCheckboxes.first;
    if (questionCheckboxToFocus) {
      questionCheckboxToFocus.focus();
    } else {
      this.focusCreateQuestion();
    }
  }

  private focusSelectAllCheckboxOrCreateQuestion(): void {
    this.cdr.detectChanges();
    if (this.selectAllCheckboxRef?.inputElement?.nativeElement) {
      this.selectAllCheckboxRef.inputElement.nativeElement.focus();
    } else {
      this.focusCreateQuestion();
    }
  }

  private setTruncateLength(): void {
    if (this.leftPanelHeader) {
      const width = this.leftPanelHeader.nativeElement.offsetWidth;
      this.titleTruncateLength = width > this.truncateWidthLimit
        ? this.defaultTitleCharLength
        : this.smallViewTitleCharLength
    }
  }

  private showHideMulQuestionKebab(): void {
    if (this.screenWidth < 576 || this.screenWidth >= 768 && this.screenWidth < 1065) {
      this.mulQuestionActionKebabShow = true;
    } else {
      this.mulQuestionActionKebabShow = false;
      this.mulQuestionActionKebabOptionShow = false;
    }
  }

  /**
   * Announces a message to screen readers with a delay.
   * When announcement and focus change occur simultaneously, VoiceOver skips the announcement in favor of reading the focused element.
   * Adding a delay ensures the announcement is read after the focused element.
   * 
   * @param message The message to announce.
   * @param politeness The politeness of the announcer element (default: polite).
   * @param duration Time in milliseconds after which to clear out the announcer element (default: 8000ms).
   * @param delayMs Delay in milliseconds before announcement (default: 0ms).
   */
  private queueLiveAnnouncement(message: string, politeness: 'polite' | 'assertive' = 'polite', duration: number = 8000, delayMs: number = 0): void {
    this.liveAnnouncer.clear();
    setTimeout(() => {
      this.liveAnnouncer.announce(message, politeness, duration);
    }, delayMs);
  }

  /**
   * Stores the triggering kebab button so focus can be restored when the delete modal closes.
   * Handles part questions via the `partKebabs` ViewChildren QueryList (matched by "parentIndex.partIndex" ID),
   * and main questions via the `questionKebabs` ViewChildren QueryList and `nativeElement` querying.
   * @param obj The question being deleted
   */
  private storeKebabButtonForFocus(obj: SelectSourceQuestion): void {
    if (obj?.parentUniqueId) {
      const parent = this.selectedQuestionsListObj?.find(q => q.uniqueId === obj.parentUniqueId);
      const partIndex = parent?.parts?.findIndex(p => p.qid === obj.qid) ?? -1;
      if (parent && partIndex !== -1) {
        const kebabDivId = `${parent.index % this.pageSize}.${partIndex}`;
        const kebabDiv = this.partKebabs?.find(k => k.nativeElement.id === kebabDivId);
        this.lastTriggeringKebabButton = kebabDiv?.nativeElement?.querySelector('button') ?? null;
      }
    }
    else {
      const questionIndex = obj.index % this.pageSize;
      const kebab = this.questionKebabs?.find(k => k?.element?.nativeElement?.id === `questionKebab${questionIndex}`);
      this.lastTriggeringKebabButton = kebab?.element?.nativeElement?.querySelector('button') ?? null;
    }
  }

  checkTooltipPresent(): boolean {
    return this.dragHandleTooltips.some(tooltip => tooltip.isOpen());
  }
}
